//激活下单的
!function(){
  //首次加载禁用
  const addToCart=$('.mainAddToCart')
  if ($('#productCheckInput').length > 0) {
        addToCart.attr("disabled", "true");
        addToCart.addClass("disabled");
        addToCart.css("pointer-events","none");
    $('.productCheckInputTips').css("display","block")
    $('.productClickButton').click(function(){
   if($('.productClickButton .mainAddToCart').attr("disabled")=="disabled"){
    $('.productCheckInputTips').css("display","block")
    $('.productCheckInputDiv').css("animation",'')
     setTimeout(()=>{
    $('.productCheckInputDiv').css("animation",'shake 800ms ease-in-out')
     },0)
   }
  })
    }
  if ($('#localPickupInput').length > 0 && !$('#localPickupInput').prop('checked')) {
    $('.localPickupInputCode').css("opacity",0)
  }
  function addOtherProductToCart(element){
                      //若选择不加购激活订单，手动触发submit
     if((!element.prop('checked'))){
                  $('#'+element.attr('formid')).submit()
                  return
                } 
                 data=[{
                    id:element.attr('ids'),
                    quantity:1
                  }]
             $.ajax({
                   type : "POST",
                url : Station.Theme.shop.root + 'cart/add.js',
                dataType : "json",
                data : {items:data},
                success : function(test) {
                      //加购激活订单成功后，手动触发submit
                  $('#'+element.attr('formid')).submit()
                },
                error: function (XMLHttpRequest, textStatus) {
                      //加购激活订单失败后，手动触发submit
                             $('#'+element.attr('formid')).submit()
                }
            });
  }
  //加购的click与原有的submit冲突，此时若需要加购激活订单的话，先取消submit事件
  if($('#productActivation').length>0 || $('#matchingUl').length>0){
     addToCart.attr('type',"button")
  }
//
  $('#matchingUl .matchingInput ').change(function(e){
                      const event = e || window.event
    console.log()
    if(event.target.checked){
       $('#matchingUl .matchingInput ').attr("disabled", false);
        $('#matchingUl .matchingInput ').prop('checked',false);
        $(this).attr("disabled", "true");
        $(this).prop('checked',true);
    }
  })
                    addToCart.click(function(e){
                      const event = e || window.event
               addOtherProductToCart($('#productActivation'))
               addOtherProductToCart( $('#matchingUl .matchingInput:checked'))
                    } )
            }()
function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t), t = setTimeout(() => fn.apply(this, args), wait)
    }
}
const trapFocusHandlers = {};

function getFocusableElements(container) {
    return Array.from(container.querySelectorAll('summary, a[href], button:enabled, [tabindex]:not([tabindex^=\'-\']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'))
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin), document.removeEventListener('focusout', trapFocusHandlers.focusout), document.removeEventListener('keydown', trapFocusHandlers.keydown), elementToFocus && elementToFocus.focus()
}

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container),
        first = elements[0],
        last = elements[elements.length - 1];
    removeTrapFocus(), trapFocusHandlers.focusin = event => {
        event.target !== container && event.target !== last && event.target !== first || document.addEventListener('keydown', trapFocusHandlers.keydown)
    }, trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown)
    }, trapFocusHandlers.keydown = function (event) {
        'TAB' === event.code.toUpperCase() && (event.target !== last || event.shiftKey || (event.preventDefault(), first.focus()), event.target !== container && event.target !== first || !event.shiftKey || (event.preventDefault(), last.focus()))
    }, document.addEventListener('focusout', trapFocusHandlers.focusout), document.addEventListener('focusin', trapFocusHandlers.focusin), elementToFocus.focus()
}

function hideOnClickOutside(element) {
    document.addEventListener('click', event => {
        var elem;
        !element.contains(event.target) && ((elem = element) && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)) && element.closest('details')?.removeAttribute('open')
    })
}

function getSectionIdByName(sectionName) {
    const sectionElement = document.querySelector(`[id$="__${sectionName}"]`);
    if (!sectionElement) return '';
    const parts = sectionElement.id.split('shopify-section-');
    return parts.length > 0 ? parts[1] : ''
}

function getJsonFromScriptTag(id) {
    const jsonTag = document.querySelector(id);
    return jsonTag && jsonTag.innerHTML.length ? JSON.parse(jsonTag.innerHTML) : {}
}

function skupThrottle(func, wait = 100) {
    let timer = null;
    return (...args) => {
        null === timer && (timer = setTimeout(() => {
            func.apply(this, args), timer = null
        }, wait))
    }
}

function _typeof(obj) {
    return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
    })(obj)
}

function _typeof(obj) {
    return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
    })(obj)
}

function _typeof(obj) {
    return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
    })(obj)
}

function _typeof(obj) {
    return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
    })(obj)
}

function _defineProperty(obj, key, value) {
    return key in obj ? Object.defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : obj[key] = value, obj
}

function _typeof(obj) {
    return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
    })(obj)
}
Station.theme = Station.theme || {}, Station.theme.A11yDropdown = function () {
        const classes_active = 'active',
            key_enter = 13,
            key_space = 32,
            key_esc = 27,
            key_tab = 9;

        function A11yDropdown(trigger, dropdown) {
            this.trigger = trigger, this.triggerParent = trigger.parentElement, this.dropdown = dropdown, this.dropdownFirstLink = dropdown.querySelector('a'), this._setupListeners()
        }
        return A11yDropdown.prototype = {
            ...A11yDropdown.prototype,
            _setupListeners() {
                this.eventHandlers = this._setupEventHandlers(), this.trigger.addEventListener('keydown', this.eventHandlers.handleTriggerKey), this.dropdown.addEventListener('keydown', this.eventHandlers.handleDropdownEsc), this.dropdown.addEventListener('focusout', this.eventHandlers.handleDropdownFocusOut)
            },
            _setupEventHandlers() {
                return {
                    handleTriggerKey: this._handleTriggerKey.bind(this),
                    handleDropdownEsc: this._handleDropdownEsc.bind(this),
                    handleDropdownFocusOut: this._handleDropdownFocusOut.bind(this)
                }
            },
            _handleTriggerKey(evt) {
                const {
                    keyCode: keyCode
                } = evt;
                keyCode !== key_enter && keyCode !== key_space || (evt.preventDefault(), this.triggerParent.classList.add(classes_active), this.trigger.setAttribute('aria-expanded', !0), this.dropdownFirstLink.focus())
            },
            _handleDropdownEsc(evt) {
                const {
                    keyCode: keyCode
                } = evt;
                keyCode !== key_tab && keyCode !== key_enter && keyCode !== key_space && keyCode === key_esc && (this.triggerParent.classList.remove(classes_active), this.trigger.setAttribute('aria-expanded', !1), this.trigger.focus())
            },
            _handleDropdownFocusOut(evt) {
                const childInFocus = evt.currentTarget.contains(evt.relatedTarget);
                this.triggerParent.classList.contains(classes_active) && !childInFocus && (this.triggerParent.classList.remove(classes_active), this.trigger.setAttribute('aria-expanded', !1))
            },
            destroy() {
                this.trigger.removeEventListener('keydown', this.eventHandlers.handleTriggerKey), this.dropdown.removeEventListener('keydown', this.eventHandlers.handleDropdownEsc), this.dropdown.removeEventListener('focusout', this.eventHandlers.handleDropdownFocusOut)
            }
        }, A11yDropdown
    }(), Station.Theme = Station.Theme || {}, Station.Theme.ProductModel = function () {
        const modelJsonSections = {},
            models = {},
            xrButtons = {},
            selectors_sectionById = id => '#shopify-section-' + id,
            selectors_productMediaTypeModel = '[data-product-media-type-model]',
            selectors_mediaGroup = '[data-product-single-media-group]',
            selectors_xrButton = '[data-shopify-xr]',
            selectors_modelViewer = '.xr-viewer',
            selectors_jsonModelById = id => '#ModelJson-' + id,
            attributes_mediaId = 'data-media-id',
            attributes_modelId = 'data-model-id';

        function setupShopifyXr(errors) {
            if (!errors)
                if (window.ShopifyXR) {
                    for (let sectionId in modelJsonSections)
                        if (modelJsonSections.hasOwnProperty(sectionId)) {
                            const modelSection = modelJsonSections[sectionId];
                            if (modelSection.loaded) continue;
                            const modelJson = document.querySelector(selectors_jsonModelById(sectionId));
                            window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML)), modelSection.loaded = !0
                        } window.ShopifyXR.setupXRElements()
                } else document.addEventListener('shopify_xr_initialized', (function () {
                  console.log(111111)
                    setupShopifyXr()
                }))
        }

        function setupModelViewerUi(errors) {
            if (!errors)
                for (let key in models)
                    if (models.hasOwnProperty(key)) {
                        const model = models[key];
                        model.modelViewerUi || (model.modelViewerUi = new Shopify.ModelViewerUI(model.element)), setupModelViewerListeners(model)
                    }
        }

        function setupModelViewerListeners(model) {
            const xrButton = xrButtons[model.sectionId];
            model.container.addEventListener('mediaVisible', evt => {
                xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId)
            }), model.container.addEventListener('mediaHidden', evt => {
                xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId)
            })
        }
        return {
            init: function (sectionId) {
                const modelViewerContainers = document.querySelector(selectors_sectionById(sectionId)).querySelectorAll(selectors_productMediaTypeModel);
                  console.log(modelViewerContainers)
                modelViewerContainers.length < 1 || (modelJsonSections[sectionId] = {
                    loaded: !1
                }, modelViewerContainers.forEach((function (modelViewerContainer, index) {
                    const mediaId = modelViewerContainer.getAttribute(attributes_mediaId),
                        modelViewerElement = modelViewerContainer.querySelector(selectors_modelViewer),
                        modelId = modelViewerContainer.getAttribute(attributes_modelId);
                    if (0 === index) {
                        const xrButton = modelViewerContainer.closest(selectors_mediaGroup).querySelector(selectors_xrButton);
                        xrButtons[sectionId] = {
                            element: xrButton,
                            defaultId: modelId
                        }
                    }
                    models[mediaId] = {
                        modelId: modelId,
                        sectionId: sectionId,
                        container: modelViewerContainer,
                        element: modelViewerElement
                    }
                })), window.Shopify.loadFeatures([{
                    name: 'shopify-xr',
                    version: '1.0',
                    onLoad: setupShopifyXr
                }, {
                    name: 'model-viewer-ui',
                    version: '1.0',
                    onLoad: setupModelViewerUi
                }]))
            },
            removeSectionModels: function (sectionId) {
                for (var key in models) {
                    if (models.hasOwnProperty(key)) models[key].sectionId === sectionId && (models[key].modelViewerUi.destroy(), delete models[key])
                }
                delete modelJsonSections[sectionId]
            }
        }
    }(),
    function () {
        window.Station || (window.Station = {
            App: {
                config: {
                    mediumScreen: 640,
                    largeScreen: 1024
                }
            }
        }), window.Station.GrandCentral = {
            version: '1.2.11'
        }
    }.call(void 0),
    function () {
        var $, closePanels, init, openPanel;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.Accordions = ($ = jQuery.noConflict(), closePanels = function ($accordion, animated) {
            var $openPanels;
            return void 0 === animated && (animated = !0), $openPanels = $('>dt.open', $accordion), animated ? $openPanels.removeClass('open').next('dd').velocity('slideUp', {
                duration: 400,
                easing: 'easeOutQuint',
                queue: !1,
                complete: function () {
                    return $accordion.data('locked', !1)
                }
            }) : $openPanels.removeClass('open').next('dd').hide(), !1
        }, openPanel = function ($panel, animated) {
            var $accordion;
            return void 0 === animated && (animated = !0), $accordion = $panel.closest('.accordion'), $panel.addClass('open'), animated ? $panel.addClass('open').next('dd').velocity('slideDown', {
                duration: 400,
                easing: 'easeOutQuint',
                queue: !1,
                complete: function () {
                    return $accordion.data('locked', !1)
                }
            }) : $panel.next('dd').show(), !1
        }, init = function () {
            return $('.accordion').each((function (i) {
                var $openPanels, $panels, self;
                return self = this, $openPanels = ($panels = $('>dt', this)).filter('.open'), $(this).data('locked', !1), $openPanels.length && $openPanels.each((function () {
                    return openPanel($(this), !1)
                })), $panels.each((function () {
                    var $panel;
                    return $panel = $(this).closest('dt'), $('>a', this).on('click', (function (e) {
                        return e.preventDefault(), $(self).data('locked') || ($(self).data('locked', !0), $panel.hasClass('open') ? closePanels($(self)) : (closePanels($(self)), openPanel($panel))), !1
                    }))
                }))
            })), !1
        }, $(document).ready((function () {
            return init()
        })), {
            init: init,
            closePanels: closePanels,
            openPanel: openPanel
        })
    }.call(void 0),
    function () {
        var $, canPlayType, eCancel, eMove, eStart, isTouch, secondsToTime;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.AudioPlayer = ($ = jQuery.noConflict(), isTouch = 'ontouchstart' in window, eStart = isTouch ? 'touchstart' : 'mousedown', eMove = isTouch ? 'touchmove' : 'mousemove', eCancel = isTouch ? 'touchcancel' : 'mouseup', canPlayType = function (file) {
            var audioElement;
            return !(!(audioElement = document.createElement('audio')).canPlayType || !audioElement.canPlayType('audio/' + file.split('.').pop().toLowerCase() + ';').replace(/no/, ''))
        }, secondsToTime = function (secs) {
            var hours, hoursDiv, minutes, minutesDiv, seconds;
            return hoursDiv = secs / 3600, hours = Math.floor(hoursDiv), minutesDiv = secs % 3600 / 60, minutes = Math.floor(minutesDiv), (seconds = Math.ceil(secs % 3600 % 60)) > 59 && (seconds = 0, minutes = Math.ceil(minutesDiv)), minutes > 59 && (minutes = 0, hours = Math.ceil(hoursDiv)), (0 === hours ? '' : hours > 0 && hours.toString().length < 2 ? '0' + hours + ':' : hours + ':') + (minutes.toString().length < 2 ? '0' + minutes : minutes) + ':' + (seconds.toString().length < 2 ? '0' + seconds : seconds)
        }, $.fn.audioPlayer = function (params) {
            var cssClass, cssClassSub, subName;
            for (subName in params = $.extend({
                    classPrefix: 'audioplayer',
                    strPlay: 'Play',
                    strPause: 'Pause',
                    strVolume: 'Volume'
                }, params), cssClass = {}, cssClassSub = {
                    playPause: 'playpause',
                    playing: 'playing',
                    stopped: 'stopped',
                    time: 'time',
                    timeCurrent: 'time-current',
                    timeDuration: 'time-duration',
                    bar: 'bar',
                    barLoaded: 'bar-loaded',
                    barPlayed: 'bar-played',
                    volume: 'volume',
                    volumeButton: 'volume-button',
                    volumeAdjust: 'volume-adjust',
                    noVolume: 'novolume',
                    muted: 'muted',
                    mini: 'mini'
                }) cssClass[subName] = params.classPrefix + '-' + cssClassSub[subName];
            return this.each((function () {
                var $this, adjustCurrentTime, adjustVolume, audioFile, barLoaded, barPlayed, isAutoPlay, isLoop, isSupport, theAudio, theBar, thePlayer, timeCurrent, timeDuration, updateLoadBar, volumeAdjuster, volumeButton, volumeDefault, volumeTestDefault, volumeTestValue;
                if ('audio' !== $(this).prop('tagName').toLowerCase()) return !1;
                $this = $(this), audioFile = $this.attr('src'), isSupport = !1, isAutoPlay = '' === (isAutoPlay = $this.get(0).getAttribute('autoplay')) || 'autoplay' === isAutoPlay, isLoop = '' === (isLoop = $this.get(0).getAttribute('loop')) || 'loop' === isLoop, void 0 === audioFile ? $('source', $this).each((function () {
                    if (void 0 !== (audioFile = $(this).attr('src')) && canPlayType(audioFile)) return isSupport = !0, !1
                })) : canPlayType(audioFile) && (isSupport = !0), thePlayer = $('<div class="not-fitvid ' + params.classPrefix + '">' + (isSupport ? $('<div>').append($this.eq(0).clone()).html() : '<embed src="' + audioFile + '" width=0 height=0 volume=100 autostart="' + isAutoPlay.toString() + '" type="audio/mpeg" loop="' + isLoop.toString() + '" />') + '<div class="' + cssClass.playPause + '" title="' + params.strPlay + '"><a href="#">"' + params.strPlay + '"</a></div></div>'), theAudio = $(isSupport ? 'audio' : 'embed', thePlayer).get(0), isSupport ? (adjustCurrentTime = function (e) {
                    var theRealEvent;
                    theRealEvent = isTouch ? e.originalEvent.touches[0] : e, theAudio.currentTime = Math.round(theAudio.duration * (theRealEvent.pageX - theBar.offset().left) / theBar.width())
                }, adjustVolume = function (e) {
                    var theRealEvent;
                    theRealEvent = isTouch ? e.originalEvent.touches[0] : e, theAudio.volume = Math.abs((theRealEvent.pageY - (volumeAdjuster.offset().top + volumeAdjuster.height())) / volumeAdjuster.height())
                }, updateLoadBar = function () {
                    var interval;
                    interval = setInterval((function () {
                        if (theAudio.buffered.length < 1) return !0;
                        barLoaded.width(theAudio.buffered.end(0) / theAudio.duration * 100 + '%'), Math.floor(theAudio.buffered.end(0)) >= Math.floor(theAudio.duration) && clearInterval(interval)
                    }), 100)
                }, volumeDefault = 0, $('audio', thePlayer).css({
                    width: 0,
                    height: 0,
                    visibility: 'hidden'
                }), thePlayer.append('<div class="' + cssClass.time + ' ' + cssClass.timeCurrent + '"></div><div class="' + cssClass.bar + '"><div class="' + cssClass.barLoaded + '"></div><div class="' + cssClass.barPlayed + '"></div></div><div class="' + cssClass.time + ' ' + cssClass.timeDuration + '"></div><div class="' + cssClass.volume + '"><div class="' + cssClass.volumeButton + '" title="' + params.strVolume + '"><a href="#">"' + params.strVolume + '"</a></div><div class="' + cssClass.volumeAdjust + '"><div><div></div></div></div></div>'), theBar = $('.' + cssClass.bar, thePlayer), barPlayed = $('.' + cssClass.barPlayed, thePlayer), barLoaded = $('.' + cssClass.barLoaded, thePlayer), timeCurrent = $('.' + cssClass.timeCurrent, thePlayer), timeDuration = $('.' + cssClass.timeDuration, thePlayer), volumeButton = $('.' + cssClass.volumeButton, thePlayer), volumeAdjuster = $('.' + cssClass.volumeAdjust + ' > div', thePlayer), volumeTestDefault = theAudio.volume, volumeTestValue = theAudio.volume = .111, Math.round(1e3 * theAudio.volume) / 1e3 === volumeTestValue ? theAudio.volume = volumeTestDefault : thePlayer.addClass(cssClass.noVolume), timeDuration.html('&hellip;'), timeCurrent.html(secondsToTime(0)), theAudio.addEventListener('loadeddata', (function () {
                    updateLoadBar(), timeDuration.html($.isNumeric(theAudio.duration) ? secondsToTime(theAudio.duration) : '&hellip;'), volumeAdjuster.find('div').height(100 * theAudio.volume + '%'), volumeDefault = theAudio.volume
                })), theAudio.addEventListener('timeupdate', (function () {
                    timeCurrent.html(secondsToTime(theAudio.currentTime)), barPlayed.width(theAudio.currentTime / theAudio.duration * 100 + '%')
                })), theAudio.addEventListener('volumechange', (function () {
                    volumeAdjuster.find('div').height(100 * theAudio.volume + '%'), theAudio.volume > 0 && thePlayer.hasClass(cssClass.muted) && thePlayer.removeClass(cssClass.muted), theAudio.volume <= 0 && !thePlayer.hasClass(cssClass.muted) && thePlayer.addClass(cssClass.muted)
                })), theAudio.addEventListener('ended', (function () {
                    thePlayer.removeClass(cssClass.playing).addClass(cssClass.stopped)
                })), theBar.on(eStart, (function (e) {
                    adjustCurrentTime(e), theBar.on(eMove, (function (e) {
                        adjustCurrentTime(e)
                    }))
                })).on(eCancel, (function () {
                    theBar.unbind(eMove)
                })), volumeButton.on('click', (function () {
                    return thePlayer.hasClass(cssClass.muted) ? (thePlayer.removeClass(cssClass.muted), theAudio.volume = volumeDefault) : (thePlayer.addClass(cssClass.muted), volumeDefault = theAudio.volume, theAudio.volume = 0), !1
                })), volumeAdjuster.on(eStart, (function (e) {
                    adjustVolume(e), volumeAdjuster.on(eMove, (function (e) {
                        adjustVolume(e)
                    }))
                })).on(eCancel, (function () {
                    volumeAdjuster.unbind(eMove)
                }))) : thePlayer.addClass(cssClass.mini), thePlayer.addClass(isAutoPlay ? cssClass.playing : cssClass.stopped), $('.' + cssClass.playPause, thePlayer).on('click', (function () {
                    return thePlayer.hasClass(cssClass.playing) ? ($(this).attr('title', params.strPlay).find('a').html(params.strPlay), thePlayer.removeClass(cssClass.playing).addClass(cssClass.stopped), isSupport ? theAudio.pause() : theAudio.Stop()) : ($(this).attr('title', params.strPause).find('a').html(params.strPause), thePlayer.addClass(cssClass.playing).removeClass(cssClass.stopped), isSupport ? theAudio.play() : theAudio.Play()), !1
                })), $this.replaceWith(thePlayer)
            }))
        }, $(document).ready((function () {
            return $('audio').audioPlayer()
        })))
    }.call(void 0),
    function () {
        var $, closeNode, defaults, init, openNode, reset;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.NavPrimary = ($ = jQuery.noConflict(), defaults = {
            easing: 'easeOutCirc',
            nodeTransitionDuration: 300
        }, closeNode = function ($node) {
            $node.closest('li').removeClass('nav-open').end().velocity('stop').velocity({
                height: 0
            }, {
                display: 'none',
                duration: defaults.nodeTransitionDuration,
                easing: defaults.easing,
                queue: !1
            })
        }, openNode = function ($node) {
            $node.closest('li').addClass('nav-open').end().css({
                height: 'auto'
            }).velocity('stop').velocity({
                height: [$node.outerHeight(), 0]
            }, {
                display: 'block',
                duration: defaults.nodeTransitionDuration,
                easing: defaults.easing,
                queue: !1,
                complete: function () {
                    $(this).css('height', 'auto')
                }
            })
        }, reset = function () {
            $('.nav-primary').each((function () {
                return $('ul', this).removeAttr('style'), $('.nav-open', this).removeClass('nav-open')
            }))
        }, init = function () {
            $('.nav-primary').each((function () {
                var $nodes, $rootNode, $toggleSelector, navID, self;
                self = this, navID = $(this).data('nav-id'), $nodes = $('ul', this), $rootNode = $('> ul', this).first(), $toggleSelector = $('.nav-toggle[data-nav-id=\'' + navID + '\']'), $nodes.each((function () {
                    var level, node;
                    return node = this, level = parseInt($(this).parentsUntil(self, 'ul').length + 1), $(this).addClass('nav-level-' + level).closest('li').addClass('nav-node').attr('aria-haspopup', !0).children(':first-child').on('mouseover', (function (e) {
                        return e.stopPropagation()
                    })).on('click', (function (e) {
                        var isEmptyLink, isOpen;
                        isEmptyLink = '' === $(this).attr('href') || '#' === $(this).attr('href'), isOpen = $(node).closest('li').hasClass('nav-open'), 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ? !0 !== $(this).data('nav-item-touched') ? (e.preventDefault(), $(this).data('nav-item-touched', !0), openNode($(node))) : !isEmptyLink && isOpen || (e.preventDefault(), $(this).data('nav-item-touched', !1), closeNode($(node))) : 'small' === Station.GrandCentral.Utilities.screenSize() && (isEmptyLink ? (e.preventDefault(), isOpen ? closeNode($(node)) : openNode($(node))) : !0 !== $(this).data('nav-item-touched') ? (e.preventDefault(), $(this).data('nav-item-touched', !0), openNode($(node))) : !isEmptyLink && isOpen || (e.preventDefault(), $(this).data('nav-item-touched', !1), closeNode($(node))))
                    }))
                })), $toggleSelector.on('click', (function (e) {
                    return $rootNode.hasClass('nav-open') ? ($(this).removeClass('nav-open'), $rootNode.removeClass('nav-open'), closeNode($rootNode)) : ($(this).addClass('nav-open'), $rootNode.addClass('nav-open'), openNode($rootNode))
                }))
            }))
        }, $(document).ready((function () {
            var windowWidth;
            return windowWidth = $(window).width(), init(), $(window).on('resize', (function () {
                if ($(window).width() !== windowWidth) return windowWidth = $(window).width(), reset()
            }))
        })), {
            init: init,
            closeNode: closeNode,
            openNode: openNode,
            reset: reset
        })
    }.call(void 0),
    function () {
        var $, closeKinNodes, closeNode, defaults, init, openNode, toggleNode;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.NavSide = ($ = jQuery.noConflict(), defaults = {
            closeKin: !1,
            easingKin: 'easeInOutCirc',
            easing: 'easeOutCirc',
            nodeTransitionDuration: 300
        }, closeKinNodes = function ($node) {
            var duration;
            duration = $node.closest('.nav-side').data('node-transition-duration'), $node.closest('li').siblings('.nav-open').find('ul').each((function () {
                closeNode($(this), duration, !0)
            }))
        }, closeNode = function ($node, nodeTransitionDuration, closeKin) {
            nodeTransitionDuration = void 0 !== nodeTransitionDuration ? nodeTransitionDuration : defaults.nodeTransitionDuration, $node.closest('li').removeClass('nav-open'), nodeTransitionDuration > 0 ? $node.velocity('stop').velocity({
                height: 0
            }, {
                display: 'none',
                duration: nodeTransitionDuration,
                easing: closeKin ? defaults.easingKin : defaults.easing,
                queue: !1
            }) : $node.css({
                height: 0
            }).hide()
        }, openNode = function ($node, nodeTransitionDuration, closeKin) {
            nodeTransitionDuration = void 0 !== nodeTransitionDuration ? nodeTransitionDuration : defaults.nodeTransitionDuration, closeKin = void 0 !== closeKin ? closeKin : defaults.closeKin, $node.closest('li').addClass('nav-open').end().css({
                height: 'auto'
            }), nodeTransitionDuration > 0 ? $node.velocity('stop').velocity({
                height: [$node.outerHeight(), 0]
            }, {
                display: 'block',
                duration: nodeTransitionDuration,
                easing: closeKin ? defaults.easingKin : defaults.easing,
                queue: !1,
                complete: function () {
                    $(this).css('height', 'auto')
                }
            }) : $node.show(), closeKin && closeKinNodes($node)
        }, toggleNode = function ($node, nodeTransitionDuration, closeKin) {
            nodeTransitionDuration = void 0 !== nodeTransitionDuration ? nodeTransitionDuration : defaults.nodeTransitionDuration, closeKin = void 0 !== closeKin ? closeKin : defaults.closeKin, $node.closest('li').hasClass('nav-open') ? closeNode($node, nodeTransitionDuration, closeKin) : openNode($node, nodeTransitionDuration, closeKin)
        }, init = function () {
            return $('.nav-side').each((function () {
                var $nodes, closeKin, expanded, nodeTransitionDuration, rootNode;
                rootNode = this, closeKin = $(this).data('close-kin'), expanded = $(this).data('expanded'), nodeTransitionDuration = $(this).data('node-transition-duration'), $nodes = $('ul', this), $(this).addClass('nav-level-1'), $nodes.each((function () {
                    var $openNodes, level, node;
                    if (node = this, level = parseInt($(this).parentsUntil(rootNode, 'ul').length + 2), $(this).addClass('nav-level-' + level), expanded && $(this).closest('li').addClass('nav-open').end().css({
                            height: 'auto',
                            display: 'block'
                        }), $(this).closest('li').addClass('nav-node').children(':first-child').on('click', (function (e) {
                            var isEmptyLink, isOpen;
                            isEmptyLink = '' === $(this).attr('href') || '#' === $(this).attr('href'), isOpen = $(node).closest('li').hasClass('nav-open'), 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ? !0 !== $(this).data('nav-item-touched') ? (e.preventDefault(), $(this).data('nav-item-touched', !0), toggleNode($(node), nodeTransitionDuration, closeKin)) : isOpen && isEmptyLink && (e.preventDefault(), $(this).data('nav-item-touched', !1), toggleNode($(node), nodeTransitionDuration, closeKin)) : !isEmptyLink && isOpen || (e.preventDefault(), toggleNode($(node), nodeTransitionDuration, closeKin))
                        })), $(this).closest('li').hasClass('nav-open')) return ($openNodes = $(node).parentsUntil(rootNode, 'ul')).push($(node)), $openNodes.each((function () {
                        return openNode($(this), 0, !1)
                    }))
                }))
            }))
        }, $(document).ready((function () {
            return init()
        })), {
            init: init,
            closeNode: closeNode,
            openNode: openNode,
            toggleNode: toggleNode
        })
    }.call(void 0),
    function () {
        var $, $nb, ariaClose, close, init, nbTimeout, notifyBarHTML, open;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.Notify = ($ = jQuery.noConflict(), nbTimeout = '', ariaClose = Station.Theme.i18n.a11y.close, notifyBarHTML = '<div id="notify-bar" role="dialog"><div class="message"></div><a href="#" class="close" data-close aria-label="' + ariaClose + '">&times;</div>', $nb = {}, init = function () {
            return $('body').prepend(notifyBarHTML), ($nb = $('#notify-bar')).hide()
        }, close = function () {
            return $nb.hasClass('inline') ? $nb.velocity({
                'margin-top': -$nb.outerHeight()
            }, {
                duration: 200,
                easing: 'easeInExpo',
                queue: !1,
                complete: function () {
                    return $nb.hide().find('.message').html('')
                }
            }) : $nb.velocity({
                translateY: '-100%'
            }, {
                duration: 200,
                easing: 'easeInExpo',
                queue: !1,
                complete: function () {
                    return clearTimeout(nbTimeout), $nb.removeAttr('style').hide().find('.message').html('')
                }
            })
        }, open = function (message, type, duration, sticky, inline, showTime) {
            type || (type = 'slate'), duration || (duration = 6e3), sticky || (sticky = !1), inline || (inline = !1), showTime || (showTime = !1), clearTimeout(nbTimeout), $('.message', $nb).html(message), $('.timer', $nb).remove(), $nb.removeClass('inline').removeAttr('style').attr('class', type), $('a[data-close]', $nb).on('click', (function (e) {
                return e.preventDefault(), close()
            })), inline ? $nb.addClass('inline').show().velocity({
                'margin-top': [0, -$nb.outerHeight()]
            }, {
                duration: 300,
                easing: 'easeOutCirc',
                queue: !1
            }) : $nb.show().velocity({
                translateY: [0, '-100%']
            }, {
                duration: 300,
                easing: 'easeOutCirc',
                queue: !1
            }), sticky || (nbTimeout = setTimeout(close, duration), showTime && $('<div>').addClass('timer').prependTo($nb).velocity({
                width: ['100%', 0]
            }, {
                duration: duration,
                easing: 'linear',
                queue: !1
            })), $nb[0].setAttribute('tabindex', -1), $nb[0].focus(), $nb[0].addEventListener('blur', (function (evt) {
                evt.target.removeAttribute('tabindex')
            }), {
                once: !0
            })
        }, $(document).ready((function () {
            return init()
        })), $(document).on('keydown', (function (e) {
            27 === e.keyCode && close()
        })), {
            init: init,
            close: close,
            open: open
        })
    }.call(void 0),
    function () {
        var $, closeTabs, init, openTab;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.Tabs = ($ = jQuery.noConflict(), openTab = function ($tab) {
            if (!$tab.hasClass('open')) return $tab.addClass('open')
        }, closeTabs = function (tabs) {
            return $('.tab.open', tabs).removeClass('open')
        }, init = function () {
            return $('.tabs').each((function (i) {
                var self;
                return self = this, $('.tab.open', this).length || openTab($('.tab', this).first()), $(this).on('click', '.tab-title', (function (e) {
                    var $tab;
                    if ($tab = $(this).closest('.tab'), e.preventDefault(), !$tab.hasClass('open')) return closeTabs(self), openTab($tab)
                }))
            }))
        }, $(document).ready((function () {
            return init()
        })), {
            init: init,
            closeTabs: closeTabs,
            openTab: openTab
        })
    }.call(void 0),
    function () {
        var $, _locationHash, _locationSearch, _newState, _replaceState, _urlParam, arraysEqual, config, delay, getParam, msieVersion, onAjaxError, removeProtocol, screenSize, setParam, switchElement;
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.Utilities = ($ = jQuery.noConflict(), config = Station.App.config, $.fn.randomize = function (selector) {
            return (selector ? this.find(selector) : this).parent().each((function () {
                return $(this).children(selector).sort((function () {
                    return Math.random() - .5
                }))
            }))
        }, $.fn.randomizeInPlace = function (selector) {
            return (selector ? this.find(selector) : this).parent().each((function () {
                return $(this).children(selector).sort((function () {
                    return Math.random() - .5
                })).detach().appendTo(this)
            }))
        }, arraysEqual = function (a, b) {
            if ('object' === _typeof(a) && 'object' === _typeof(b)) return a.length === b.length && a.every((function (elem, i) {
                return elem === b[i]
            }))
        }, delay = function (ms, func) {
            return setTimeout(func, ms)
        }, getParam = function (param) {
            var m, pattern;
            return pattern = new RegExp('[?&]' + param + '((=([^&]*))|(?=(&|$)))', 'i'), (m = window.location.search.match(pattern)) && (void 0 === m[3] ? '' : m[3])
        }, msieVersion = function () {
            var msie, ua;
            return (msie = (ua = window.navigator.userAgent).indexOf('MSIE ')) > 0 && parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)))
        }, onAjaxError = function (XMLHttpRequest, textStatus, showError, message) {
            var response, responseMessage;
            return responseMessage = (response = $.parseJSON(XMLHttpRequest.responseText)).message + ': ' + response.description, message || (message = responseMessage), console.log(textStatus), console.log(response)
        }, removeProtocol = function (e) {
            return e.replace(/http(s)?:/, '')
        }, screenSize = function () {
            var queryMedium, querySmall;
            return querySmall = 'screen and (max-width: ' + config.mediumScreen + 'px)', queryMedium = 'screen and (min-width: ' + config.mediumScreen + 'px) and (max-width: ' + config.largeScreen + 'px)', window.matchMedia(querySmall).matches ? 'small' : window.matchMedia(queryMedium).matches ? 'medium' : 'large'
        }, setParam = function (e, t) {
            window.history && window.history.replaceState && _replaceState(_newState(e, t))
        }, switchElement = function (hide, show, addClass) {
            var $show;
            ($show = $(show)) && ($(hide).hide(), $show.addClass(addClass).show())
        }, _locationSearch = function () {
            return window.location.search
        }, _locationHash = function () {
            return window.location.hash
        }, _newState = function (e, t) {
            return (_urlParam(e) ? _locationSearch().replace(RegExp('(' + e + '=)[^&#]+'), '$1' + t) : '' === _locationSearch() ? '?' + e + '=' + t : _locationSearch() + '&' + e + '=' + t) + _locationHash()
        }, _replaceState = function (e) {
            window.history.replaceState({}, document.title, e)
        }, _urlParam = function (e) {
            var t;
            return (t = RegExp('[?&]' + e + '=([^&#]*)').exec(_locationSearch())) && decodeURIComponent(t[1].replace(/\+/g, ' '))
        }, $('[data-target-new]').attr('target', '_blank'), $('[data-target-new]').attr('rel', 'noopener'), $('[data-click-history-back]').on('click', (function () {
            return window.history.back(), !1
        })), $('[data-auto-focus]').focus(), $('form:not([html-validate])').attr('novalidate', ''), {
            arraysEqual: arraysEqual,
            delay: delay,
            getParam: getParam,
            msieVersion: msieVersion,
            onAjaxError: onAjaxError,
            removeProtocol: removeProtocol,
            screenSize: screenSize,
            setParam: setParam,
            switchElement: switchElement
        })
    }.call(void 0),
    function () {
        var $, buildCustomTransitions, init, setDefaults;
        Station.GrandCentral.Vendor = Station.GrandCentral.Vendor || {}, Station.GrandCentral.Vendor.FancyBox = ($ = jQuery.noConflict(), buildCustomTransitions = function (F) {
            F.transitions.grandCentralIn = function () {
                F.wrap.velocity({
                    opacity: [1, 0],
                    translateY: [0, -20]
                }, {
                    duration: F.current.openSpeed,
                    easing: F.current.openEasing,
                    complete: F._afterZoomIn
                })
            }, F.transitions.grandCentralOut = function () {
                F.wrap.removeClass('fancybox-opened').velocity({
                    opacity: 0,
                    translateY: -20
                }, {
                    duration: F.current.closeSpeed,
                    easing: F.current.closeEasing,
                    complete: function () {
                        return F._afterZoomOut()
                    }
                })
            }, F.transitions.grandCentralChangeIn = function () {
                var direction, tX, tY;
                'left' === (direction = F.direction) && (tX = [0, 60], tY = 0), 'right' === direction && (tX = [0, -60], tY = 0), 'up' === direction && (tX = 0, tY = [0, 60]), 'down' === direction && (tX = 0, tY = [0, -60]), F.wrap.velocity({
                    opacity: [1, 0],
                    translateX: tX,
                    translateY: tY
                }, {
                    duration: F.current.nextSpeed,
                    easing: F.current.nextEasing,
                    complete: F._afterZoomIn
                })
            }, F.transitions.grandCentralChangeOut = function () {
                var direction, tX, tY;
                'left' === (direction = F.direction) && (tX = -60, tY = 0), 'right' === direction && (tX = 60, tY = 0), 'up' === direction && (tX = 0, tY = -60), 'down' === direction && (tX = 0, tY = 60), F.previous.wrap.velocity({
                    opacity: 0,
                    translateX: tX,
                    translateY: tY
                }, {
                    duration: F.current.prevSpeed,
                    easing: F.previous.easing,
                    complete: function () {
                        return $(this).trigger('onReset').remove()
                    }
                })
            }
        }, setDefaults = function () {
            return $.extend($.fancybox.defaults, {
                closeBtn: !1,
                closeEasing: 'easeInCirc',
                closeMethod: 'grandCentralOut',
                closeSpeed: 200,
                nextEasing: 'easeInOutCirc',
                nextMethod: 'grandCentralChangeIn',
                nextSpeed: 300,
                openEasing: 'easeOutCirc',
                openMethod: 'grandCentralIn',
                openSpeed: 500,
                padding: 0,
                prevEasing: 'easeInOutCirc',
                prevMethod: 'grandCentralChangeOut',
                prevSpeed: 300,
                wrapCSS: 'fancybox-grand-central',
                helpers: {
                    overlay: {
                        css: {
                            background: 'rgba(255, 255, 255, 0.94)'
                        }
                    },
                    title: {
                        type: 'inside'
                    },
                    media: {}
                },
                beforeLoad: function () {
                    var height, width;
                    if (height = parseInt(this.element.data('fancybox-height')), (width = parseInt(this.element.data('fancybox-width'))) && (this.width = width), height) return this.height = height
                },
                afterLoad: function () {
                    $('.fancybox-overlay').addClass(this.wrapCSS)
                },
                afterShow: function () {
                    $('[data-modal-close]', this.inner).on('click', (function (e) {
                        return e.preventDefault(), $.fancybox.close()
                    })), $('.fancybox-overlay > .fancybox-close-wrap').length || 'modal' !== this.element.data('modal-type') && $('<div class="fancybox-close-wrap" />').html('<div class="fancybox-close"><svg class="icon icon-close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></div>').prependTo($('.fancybox-overlay')).on('click', (function (e) {
                        return e.preventDefault(), $.fancybox.close()
                    })), $('.fancybox-nav', this.wrap).length && ($('.fancybox-overlay > .fancybox-nav-prev-wrap').length || ($('<div class="fancybox-nav-prev-wrap" />').html('<div class="fancybox-nav-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-carret-left" viewBox="0 0 10 6" width="12" height="12"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></div>').prependTo($('.fancybox-overlay')).on('click', (function () {
                        return $.fancybox.prev()
                    })), $('<div class="fancybox-nav-next-wrap" />').html('<div class="fancybox-nav-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-carret-right" viewBox="0 0 10 6" width="12" height="12"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></div>').prependTo($('.fancybox-overlay')).on('click', (function () {
                        return $.fancybox.next()
                    }))), this.wrap.hasClass('fancybox-type-ajax') && $('.fancybox-nav', this.outer).hide())
                },
                beforeClose: function () {
                    $('.fancybox-overlay').addClass('fancybox-closing')
                }
            })
        }, init = function () {
            return $('.fancybox').fancybox(), $('.fancybox[data-modal-type="modal"]').fancybox({
                modal: !0
            })
        }, $(document).ready((function () {
            if ('function' == typeof jQuery.fn.fancybox) return buildCustomTransitions(jQuery.fancybox), setDefaults(), init()
        })))
    }.call(void 0),
    function () {
        var $, _bindEvents, cache, cacheElements, config, init, initCarousel, initCarousels, selectors, hasProp = {}.hasOwnProperty;
        Station.GrandCentral.Vendor = Station.GrandCentral.Vendor || {}, Station.GrandCentral.Vendor.Flickity = ($ = jQuery.noConflict(), selectors = {
            attr: {
                options: 'data-flickity-options'
            },
            carousel: '.gc-carousel',
            pause: '[data-slider-pause]',
            pausedClass: 'slideshow__pause--is-paused'
        }, config = {
            defaultOptions: {
                arrowShape: 'M65.0491632,29.3794051 C66.0536287,28.3749397 66.0536287,26.7677949 65.0491632,25.7633294 L58.3795124,19.0936786 C57.3750469,18.0892131 55.7679022,18.0892131 54.7634367,19.0936786 L24.9509011,48.9062141 C23.9464357,49.9106796 23.9464357,51.5178244 24.9509011,52.5222899 L54.7634367,82.3348254 C55.7679022,83.3392909 57.3750469,83.3392909 58.3795124,82.3348254 L65.0491632,75.6651746 C66.0536287,74.6607091 66.0536287,73.0535643 65.0491632,72.0490989 L43.7143164,50.714252 L65.0491632,29.3794051 Z',
                autoPlay: 5e3,
                cellAlign: 'center',
                cellSelector: '.gc-carousel-cell',
                contain: !0,
                draggable: !0,
                freeScroll: !1,
                freeScrollFriction: .03,
                friction: .28,
                initialIndex: 0,
                lazyLoad: 1,
                pauseAutoPlayOnHover: !0,
                pageDots: !0,
                prevNextButtons: !0,
                selectedAttraction: .025,
                wrapAround: !0
            }
        }, cache = {}, init = function () {
            cacheElements(), _bindEvents(), initCarousels()
        }, cacheElements = function () {
            cache = {
                $carousels: $(selectors.carousel),
                carousels: document.querySelectorAll(selectors.carousel),
                pauseButtons: document.querySelectorAll(selectors.pause)
            }
        }, initCarousels = function () {
            cache.$carousels.length && cache.$carousels.each((function () {
                var $carousel;
                return $carousel = $(this), initCarousel($carousel)
            }))
        }, initCarousel = function ($carousel, options) {
            var inlineOptions;
            null == options && (options = {}), (inlineOptions = $carousel.attr('data-flickity-options')) && (inlineOptions = JSON.parse(inlineOptions)), options = $.extend(config.defaultOptions, inlineOptions, options), $carousel.flickity(options), $carousel.on('change.flickity', (function (_, index) {
                var currentSlide, id, player, ref, ref1;
                for (id in currentSlide = $carousel.data('flickity').selectedElement, $(currentSlide).find('.item-inner').css('visibility', 'visible'), ref = Station.Theme.current.players.youtube) hasProp.call(ref, id) && (player = ref[id]).getPlayerState && 1 === player.getPlayerState() && player.pauseVideo();
                for (id in ref1 = Station.Theme.current.players.vimeo) hasProp.call(ref1, id) && (player = ref1[id]).pause && player.pause()
            }))
        }, _bindEvents = function () {
            cache.pauseButtons.forEach((function (button) {
                return button.addEventListener('click', (function (e) {
                    var paused, slider;
                    return button = e.currentTarget, slider = Flickity.data(button.closest(selectors.carousel)), (paused = button.classList.contains(selectors.pausedClass)) ? (button.classList.remove(selectors.pausedClass), slider.playPlayer()) : (button.classList.add(selectors.pausedClass), slider.stopPlayer()), button.setAttribute('aria-pressed', !paused)
                })), cache.carousels.forEach((function (carousel) {
                    return carousel.addEventListener('mouseenter', (function (e) {
                        return carousel.style.boxShadow = 'none'
                    }))
                }))
            }))
        }, $((function () {
            init()
        })), {
            init: init,
            cacheElements: cacheElements,
            initCarousel: initCarousel,
            initCarousels: initCarousels
        })
    }.call(void 0),
    function () {
        var $, cache, cacheElements, checkScrollDirection, classes, eventHandlers, hideHeader, init, initA11yMenu, initFitVids, initJumpMenus, initMatchHeightConfig, initScrollListener, initShopifyExtensions, initSlideSideMenu, initStickyCart, initStickyHeader, mqMediumUp, selectors, setPageTitle, showHeader, themeConfig;
        window.Station.Theme = window.Station.Theme || {}, Station.Theme.Base = ($ = jQuery.noConflict(), selectors = {
            page: 'html, body',
            shopifySectionHeader: '#shopify-section-header',
            announcementBar: '#announcement-bar',
            appHeader: '#app-header',
            appUpperHeader: '#app-upper-header',
            appLowerHeader: '#app-lower-header',
            typeaheadContainer: '.typeahead__container',
            typeahead: '.js-typeahead',
            slideSideMenu: '#slide-side-menu',
            slideOutSideMenu: '#slide-out-side-menu',
            slideInSideMenu: '#slide-in-side-menu',
            stickyCart: '#sticky-cart',
            pageTitle: '.page-header .title',
            appBody: '#app-body',
            overlayBackground: '#overlay-background',
            a11yDropdownTrigger: '[data-a11y-dropdown]',
            dropdown: '.submenu'
        }, classes = {
            sticky: 'sticky-header'
        }, themeConfig = Station.Theme.config, cache = {}, mqMediumUp = null, eventHandlers = {}, init = function () {
            return initMatchHeightConfig(), cacheElements(), initStickyHeader(), initSlideSideMenu(), initStickyCart(), initShopifyExtensions(), initFitVids(), initJumpMenus(), initA11yMenu()
        }, initMatchHeightConfig = function () {
            if ($.fn.matchHeight && ($.fn.matchHeight._maintainScroll = !0), $.fn.matchHeight) return $.fn.matchHeight._throttle = 100
        }, cacheElements = function () {
            return cache = {
                $page: $(selectors.page),
                $shopifySectionHeader: $(selectors.shopifySectionHeader),
                $announcementBar: $(selectors.announcementBar),
                $appHeader: $(selectors.appHeader),
                $appUpperHeader: $(selectors.appUpperHeader),
                $appLowerHeader: $(selectors.appLowerHeader),
                $slideSideMenu: $(selectors.slideSideMenu),
                $slideOutSideMenu: $(selectors.slideOutSideMenu),
                $slideInSideMenu: $(selectors.slideInSideMenu),
                $stickyCart: $(selectors.stickyCart),
                $pageTitle: $(selectors.pageTitle),
                $appBody: $(selectors.appBody),
                $overlayBackground: $(selectors.overlayBackground),
                $a11yDropdownTriggers: $(selectors.a11yDropdownTrigger)
            }
        }, initStickyHeader = function () {
            mqMediumUp = window.matchMedia(themeConfig.mediaQuery.mediumUp), eventHandlers.checkScrollDirection = skupThrottle(checkScrollDirection, 100), initScrollListener(), mqMediumUp.onchange = initScrollListener.bind(this), cache.$appHeader.hasClass('sticky-on') && !cache.$appHeader.hasClass('sticky-off') ? cache.$shopifySectionHeader.addClass(classes.sticky) : cache.$shopifySectionHeader.removeClass(classes.sticky)
        }, initScrollListener = function () {
            return mqMediumUp.matches ? window.addEventListener('scroll', eventHandlers.checkScrollDirection) : window.removeEventListener('scroll', eventHandlers.checkScrollDirection)
        }, checkScrollDirection = function () {
            window.pageYOffset || document.documentElement.scrollTop
        }, initSlideSideMenu = function () {
            cache.$slideOutSideMenu.click((function (e) {
                var details;
                cache.$page.addClass('no-scroll'), $(this).attr('aria-expanded', !0), details = $(this).closest('details'), setTimeout((function () {
                    details.addClass('menu-opening')
                }))
            })), cache.$slideInSideMenu.click((function (e) {
                var details, summary;
                e.preventDefault(), summary = $(this).closest('summary').get(0), details = $(this).closest('details.slide-menu').get(0), setTimeout((function () {
                    cache.$page.removeClass('no-scroll'), details.classList.remove('menu-opening'), summary.setAttribute('aria-expanded', !1), setTimeout((function () {
                        details.removeAttribute('open')
                    }), 100)
                }), 50)
            })), cache.$slideSideMenu.find('summary').each((function () {
                $(this).click((function (e) {
                    var isOpen, summaryElement;
                    isOpen = (summaryElement = e.currentTarget).parentNode.hasAttribute('open'), summaryElement.setAttribute('aria-expanded', !isOpen)
                }))
            })), cache.$overlayBackground.click((function (e) {
                cache.$page.removeClass('no-scroll'), cache.$slideSideMenu.removeClass('active'), $(this).removeClass('active')
            }))
        }, initStickyCart = function () {
            var stickyTop;
            stickyTop = cache.$stickyCart.hasClass('top') && cache.$appHeader.hasClass('sticky-on'), cache.$stickyCart.css({
                'box-shadow': '0 0 2px rgba(0,0,0, 0.2)'
            }), stickyTop && (cache.$stickyCart.children('.sticky-cart-content').css({
                height: cache.$appUpperHeader.outerHeight() - 20
            }), $(window).on('resize orientationchange', (function (e) {
                cache.$stickyCart.children('.sticky-cart-content').css({
                    height: cache.$appUpperHeader.outerHeight() - 20
                })
            }))), $(window).scroll((function (e) {
                $(this).scrollTop() >= cache.$shopifySectionHeader.outerHeight() ? (cache.$stickyCart.addClass('active'), stickyTop && hideHeader()) : (cache.$stickyCart.removeClass('active'), stickyTop && showHeader())
            }))
        }, initFitVids = function () {
            'function' == typeof $.fn.fitVids && $('.fit-video').fitVids()
        }, initJumpMenus = function () {
            return $('select.jump-menu').change((function () {
                window.location = $('option:selected', this).val()
            }))
        }, initShopifyExtensions = function () {
            var aCouples, aKeyValue, i;
            if (Shopify.queryParams = {}, location.search.length)
                for (aKeyValue = void 0, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length;)(aKeyValue = aCouples[i].split('=')).length > 1 && (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1])), i++
        }, initA11yMenu = function () {
            if (cache.$a11yDropdownTriggers.length > 0) return cache.$a11yDropdownTriggers.each((function () {
                var submenu;
                return submenu = $(this).parent().find(selectors.dropdown).get(0), new Station.theme.A11yDropdown($(this).get(0), submenu)
            }))
        }, setPageTitle = function (text) {
            null == text && (text = cache.$pageTitle.data('default-text')), cache.$pageTitle.text(text)
        }, showHeader = function () {
            return cache.$shopifySectionHeader.removeClass('transition-opacity pointer-events-none opacity-0'), cache.$appLowerHeader.removeClass('idle')
        }, hideHeader = function () {
            return cache.$shopifySectionHeader.addClass('transition-opacity pointer-events-none opacity-0')
        }, $(window).resize((function () {
            clearTimeout(window.resizedFinished), window.resizedFinished = setTimeout((function () {
                Station.Theme.Collection.alignRows()
            }), 100)
        })), $((function () {
            init()
        })), {
            init: init,
            initStickyHeader: initStickyHeader,
            initSlideSideMenu: initSlideSideMenu,
            initStickyCart: initStickyCart,
            initFitVids: initFitVids,
            initJumpMenus: initJumpMenus,
            initShopifyExtensions: initShopifyExtensions,
            cacheElements: cacheElements,
            setPageTitle: setPageTitle
        })
    }.call(void 0),
    function () {
        var $, _initAddToCartButtons, addToCart, cache, cacheElements, config, init, lineItemAddedConfirmationMessage, selectors, updateCartTotals;
        Station.Theme = Station.Theme || {}, Station.Theme.Cart = ($ = jQuery.noConflict(), selectors = {
            attr: {
                cartAction: 'data-cart-action',
                template: 'data-template'
            },
            addToCart: '.add-to-cart',
            addToCartForm: 'form[action*=/cart/add]',
            cartBadge: '.cart-badge'
        }, Station.Theme.current, Station.Theme.config, config = {
            i18n: Station.Theme.i18n,
            shop: Station.Theme.shop,
            notify: Station.GrandCentral.Notify
        }, cache = {}, init = function (container) {
            return cacheElements(), _initAddToCartButtons()
        }, cacheElements = function () {
            return cache = {
                $addToCart: $(selectors.addToCart),
                $cartBadge: $(selectors.cartBadge)
            }
        }, addToCart = function (action, triggerElement) {
            var $triggerElement, serializedForm;
            if (action || triggerElement) switch (serializedForm = ($triggerElement = $(triggerElement)).closest(selectors.addToCartForm).serialize(), action) {
                case 'notification':
                    $triggerElement.blur(), $.ajax({
                        type: 'POST',
                        url: Station.Theme.shop.root + 'cart/add.js',
                        data: serializedForm,
                        dataType: 'json',
                        success: function (item) {
                            updateCartTotals(), config.notify.open(lineItemAddedConfirmationMessage(item), 'success')
                        },
                        error: function (XMLHttpRequest, textStatus) {
                            var responseText;
                            responseText = JSON.parse(XMLHttpRequest.responseText), config.notify.open(responseText.description, 'error')
                        }
                    });
                    break;
                default:
                    return
            }
        }, lineItemAddedConfirmationMessage = function (item) {
            var viewCartLink;
            return viewCartLink = '<div class="actions"><a class="button small" href="'.concat(config.shop.root, 'cart">').concat(config.i18n.cart.notification.viewCartLink, '</a></div>'), config.i18n.cart.notification.productAdded.replace('{{ product_title }}', item.title).replace('{{ view_cart_link }}', viewCartLink)
        }, updateCartTotals = function () {
            $.ajax({
                type: 'GET',
                url: Station.Theme.shop.root + 'cart.js',
                dataType: 'json',
                success: function (data) {
                    var count, itemCountText;
                    switch (data.item_count) {
                        case 0:
                            count = 'zero';
                            break;
                        case 1:
                            count = 'one';
                            break;
                        default:
                            count = 'other'
                    }
                    return itemCountText = config.i18n.cart.itemCount[count].replace('{{ count }}', data.item_count), $('.cart-item-count').html(data.item_count), $('.cart-item-count-items').html(itemCountText), $('.cart-total-price').html(Station.Theme.Currency.formatMoney(data.total_price)), data.item_count > 0 ? cache.$cartBadge.removeClass('empty') : cache.$cartBadge.addClass('empty')
                }
            })
        }, _initAddToCartButtons = function () {
            cache.$addToCart.each((function () {
                return $(this).on('click', (function (e) {
                    var action, template;
                    switch (template = $(this).attr(selectors.attr.template), action = $(this).attr(selectors.attr.cartAction)) {
                        case 'notification':
                            if ('cart' !== template) return e.preventDefault(), $(this).blur(), addToCart(action, this)
                    }
                }))
            }))
        }, $((function () {
            init()
        })), {
            init: init,
            addToCart: addToCart
        })
    }.call(void 0),
    function () {
        Station.Theme = Station.Theme || {}, Station.Theme.CollectionListSection = function ($) {
            return function (container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.CollectionListSection.prototype = Object.assign({}, Station.Theme.CollectionListSection.prototype, jQuery, {
            onSelect: function (evt) {
                Station.Theme.Collection.alignRows()
            }
        })
    }.call(void 0),
    function () {
        Station.Theme = Station.Theme || {}, Station.Theme.CollectionSection = function ($) {
            return function (container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.CollectionSection.prototype = Object.assign({}, Station.Theme.CollectionSection.prototype, jQuery, {
            onLoad: function (evt) {
                Station.Theme.Currency.init()
            },
            onSelect: function (evt) {
                Station.Theme.Cart.init(), Station.Theme.Collection.init(), Station.Theme.Currency.init()
            }
        })
    }.call(void 0),
    function () {
        Station.Theme = Station.Theme || {}, Station.Theme.CollectionTemplateSection = function ($) {
            return function (container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.CollectionTemplateSection.prototype = Object.assign({}, Station.Theme.CollectionTemplateSection.prototype, jQuery, {
            onLoad: function (evt) {
                Station.Theme.Cart.init()
            },
            onSelect: function (evt) {
                return Station.Theme.Cart.init(), Station.Theme.Collection.init(), Station.Theme.Currency.init()
            },
            onBlockSelect: function (evt) {
                Station.Theme.Currency.init()
            }
        })
    }.call(void 0),
    function () {
        var $, alignRows, cache, cacheElements, init, initSortMenus, selectors;
        Station.Theme = Station.Theme || {}, Station.Theme.Collection = ($ = jQuery.noConflict(), selectors = {
            listCollections: '.list-collections',
            products: '.collection-products',
            sectionCollectionList: '.section-collection-list',
            sortBy: 'select.sort-collection-by'
        }, Station.Theme.config, cache = {}, init = function () {
            cacheElements(), initSortMenus(), alignRows()
        }, cacheElements = function () {
            cache = {
                $listCollections: $(selectors.listCollections),
                $products: $(selectors.products),
                $sectionCollectionList: $(selectors.sectionCollectionList),
                $sortBy: $(selectors.sortBy)
            }
        }, alignRows = function () {
            'function' == typeof $.fn.matchHeight && (cache.$products.length && ($(selectors.products + ' .image-container').matchHeight(), $(selectors.products + ' .title-wrap').matchHeight(), $(selectors.products + ' .pricing').matchHeight()), cache.$listCollections.length && ($('.collection-grid-item .image-container').matchHeight(), $('.collection-title').matchHeight()), cache.$sectionCollectionList.length && ($('.collection-grid-item .image-container').matchHeight(), $('.collection-title').matchHeight()))
        }, initSortMenus = function () {
            cache.$sortBy.length && cache.$sortBy.each((function () {
                var $this, sortBy;
                sortBy = ($this = $(this)).attr('data-sort-by'), $(this).val(sortBy).on('change', (function () {
                    Shopify.queryParams.sort_by = $this.val(), location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20')
                }))
            }))
        }, $((function () {
            init()
        })), {
            init: init,
            cacheElements: cacheElements,
            alignRows: alignRows,
            initSortMenus: initSortMenus
        })
    }.call(void 0),
    function () {
        var $, _bindEvents, cache, cacheElements, config, convertAll, formatMoney, init, renderPrice, selectors, setCurrency;
        Station.Theme = Station.Theme || {}, Station.Theme.Currency = ($ = jQuery.noConflict(), selectors = {
            attr: {
                basePrice: 'data-base-price'
            },
            currencyCode: '[data-currency-code]',
            currencySelect: '[data-currency-selector]',
            singleOptionSelector: '[name="id"][data-option-selector]',
            price: '[data-price]'
        }, Station.Theme.config, config = {
            currentCurrency: Station.Theme.current.currency,
            moneyFormat: Station.Theme.shop.moneyFormat,
            moneyWithCurrencyFormat: Station.Theme.shop.moneyWithCurrencyFormat,
            shop: Station.Theme.shop,
            shopCurrency: Station.Theme.shop.currency
        }, cache = {}, init = function () {
            var currency;
            cacheElements(), _bindEvents(), Currency.moneyFormats[config.shopCurrency].money_format = config.moneyFormat, Currency.moneyFormats[config.shopCurrency].money_with_currency_format = config.moneyWithCurrencyFormat, currency = config.shopCurrency, Currency.currentCurrency = currency, setCurrency(currency)
        }, cacheElements = function () {
            return cache = {
                $currencyCode: $(selectors.currencyCode),
                $currencySelect: $(selectors.currencySelect),
                $price: $(selectors.price),
                $singleOptionSelector: $(selectors.singleOptionSelector)
            }
        }, convertAll = function (currency) {
            null == currency && (currency = Currency.currentCurrency), cache.$price.each((function () {
                return renderPrice(this, $(this).attr(selectors.attr.basePrice), '', currency)
            })), $('option', cache.$singleOptionSelector).each((function () {
                var amount, hasPrice, text;
                hasPrice = (text = (text = $(this).html()).substr(0, text.lastIndexOf('—') + 2)).lastIndexOf('—') > 0, amount = $(this).attr(selectors.attr.basePrice), hasPrice && (amount = amount ? formatMoney(amount, null, currency) : Station.Theme.i18n.product.soldOut, $(this).html(text + amount))
            }))
        }, formatMoney = function (amount, style, currency) {
            var format, formattedAmount;
            if (!isNaN(parseInt(amount))) return amount = amount ? parseInt(amount) : 0, currency = currency || Currency.currentCurrency, style = style || 'money_with_currency_format', format = Currency.moneyFormats[currency][style], formattedAmount = Currency.convert(amount, config.shopCurrency, currency), Currency.formatMoney(formattedAmount, format)
        }, renderPrice = function (element, amount, style, currency) {
            var $e, formattedAmount, manualStyle;
            'money_format' !== (manualStyle = ($e = $(element)).attr('data-money-style')) && 'money_with_currency_format' !== manualStyle || (style = manualStyle), isNaN(parseInt(amount)) ? (formattedAmount = amount, amount = '') : formattedAmount = formatMoney(amount, style, currency), $e.attr(selectors.attr.basePrice, amount).html(formattedAmount).addClass('converted')
        }, setCurrency = function (currency) {
            cache.$currencyCode.html(currency), cache.$currencySelect.val(currency), Currency.currentCurrency = currency, Currency.cookie.write(currency), convertAll(currency)
        }, _bindEvents = function () {
            cache.$currencySelect.on('change', (function () {
                return setCurrency($(this).val())
            }))
        }, $((function () {
            'object' === ('undefined' == typeof Currency ? 'undefined' : _typeof(Currency)) && init()
        })), {
            init: init,
            cacheElements: cacheElements,
            convertAll: convertAll,
            formatMoney: formatMoney,
            renderPrice: renderPrice,
            setCurrency: setCurrency
        })
    }.call(void 0),
    function () {
        var $, Addresses, config, _bindEvents, cache, cacheElements, deleteAddress, hideAddressForm, init, initCountryProvinceSelector, initCountryProvinceSelectors, selectors, showAddressForm, showAddressFormsWithErrors, toggleAddress;
        window.Station.Theme = window.Station.Theme || {}, Station.Theme.Customer = ($ = jQuery.noConflict(), config = {
            addressesTemplate: 'customers/addresses',
            loginTemplate: 'customers/login'
        }, Station.Theme.config, selectors = {
            addAddress: '#add_address',
            addAddressButton: '[data-form-id="add_address"]:first',
            customerAddress: '.customer-address',
            customerAddressForm: '.customer-address form',
            deleteAddress: '.delete-address',
            editAddress: '[id^="edit_address"]',
            errors: '.errors',
            toggleAddress: '.toggle-address'
        }, cache = {}, init = function () {
            return cacheElements(), _bindEvents(), initCountryProvinceSelectors(), showAddressFormsWithErrors()
        }, cacheElements = function () {
            cache = {
                $addAddressButton: $(selectors.addAddressButton),
                $pageHeaderTitle: $(selectors.pageHeaderTitle),
                $customerAddress: $(selectors.customerAddress),
                $customerAddressForm: $(selectors.customerAddressForm),
                $deleteAddress: $(selectors.deleteAddress),
                $toggleAddress: $(selectors.toggleAddress)
            }
        }, deleteAddress = function (id, confirmMessage) {
            confirm(confirmMessage) && Shopify.postLink(Station.Theme.shop.root + 'account/addresses/' + id, {
                parameters: {
                    _method: 'delete'
                }
            })
        }, hideAddressForm = function ($form) {
            $form.hide()
        }, initCountryProvinceSelector = function (id) {
            return new Shopify.CountryProvinceSelector('address_country_' + id, 'address_province_' + id, {
                hideElement: 'address_province_row_' + id
            })
        }, initCountryProvinceSelectors = function () {
            Shopify && initCountryProvinceSelector('new'), cache.$customerAddress.not(selectors.addAddress).each((function () {
                var id;
                if (id = $(this).attr('id').replace('address_', ''), Shopify) return initCountryProvinceSelector(id)
            }))
        }, showAddressForm = function ($form, $scrollToElement) {
            $form.show().addClass('animate-in fade-in-down'), $scrollToElement && $scrollToElement.length && $scrollToElement.velocity('scroll', {
                duration: 500,
                offset: -20,
                easing: 'easeInOutCirc'
            }), Station.GrandCentral.Utilities.delay(20, (function () {
                return $('input[type="text"]', $form).first().focus()
            }))
        }, showAddressFormsWithErrors = function () {
            return cache.$customerAddressForm.each((function () {
                var $form;
                $form = $(this).closest(selectors.addAddress, selectors.editAddress), $(selectors.errors, $(this)).length && showAddressForm($form, $form)
            }))
        }, toggleAddress = function (id, $scrollToElement) {
            var $form;
            ($form = $(id)).length && ($form.is(':visible') ? (hideAddressForm($form), id === selectors.addAddress && (Station.Theme.Base.setPageTitle(), cache.$addAddressButton.show())) : (id === selectors.addAddress && ($scrollToElement = $('#content-wrap'), cache.$addAddressButton.hide(), Station.Theme.Base.setPageTitle(cache.$addAddressButton.text())), showAddressForm($form, $scrollToElement)))
        }, _bindEvents = function () {
            return cache.$toggleAddress.on('click', (function (e) {
                e.preventDefault(), $(this).blur(), toggleAddress('#' + $(this).data('form-id'), $(this))
            })), cache.$deleteAddress.on('click', (function (e) {
                e.preventDefault(), $(this).blur(), deleteAddress($(this).data('form-id'), $(this).data('confirm-message'))
            }))
        }, Station.Theme.current.templateType === config.addressesTemplate && init(), Addresses = {
            init: init,
            cacheElements: cacheElements,
            deleteAddress: deleteAddress,
            hideAddressForm: hideAddressForm,
            initCountryProvinceSelector: initCountryProvinceSelector,
            initCountryProvinceSelectors: initCountryProvinceSelectors,
            showAddressForm: showAddressForm,
            showAddressFormsWithErrors: showAddressFormsWithErrors,
            toggleAddress: toggleAddress
        }, {
            Login: function () {
                var _bindEvents, cache, cacheElements, init, renderRecoverPasswordSuccess, selectors, setInitialSection;
                return selectors = {
                    loginSection: '#customer-login',
                    recoverPasswordSection: '#customer-recover-password',
                    recoverPasswordSuccess: '[data-recover-password-success]',
                    recoverPasswordSuccessTest: '#recover-password-success',
                    togglePasswordRecovery: '.toggle-password-recovery'
                }, cache = {}, init = function () {
                    return cacheElements(), _bindEvents(), setInitialSection(), renderRecoverPasswordSuccess(cache.$recoverPasswordSuccess.length)
                }, cacheElements = function () {
                    cache = {
                        $loginSection: $(selectors.loginSection),
                        $recoverPasswordSection: $(selectors.recoverPasswordSection),
                        $recoverPasswordSuccess: $(selectors.recoverPasswordSuccess),
                        $recoverPasswordSuccessTest: $(selectors.recoverPasswordSuccessTest),
                        $togglePasswordRecovery: $(selectors.togglePasswordRecovery)
                    }
                }, renderRecoverPasswordSuccess = function (visible) {
                    visible && cache.$recoverPasswordSuccessTest.show().removeClass('hidden').focus()
                }, setInitialSection = function () {
                    var section;
                    section = '#recover' === window.location.hash ? selectors.recoverPasswordSection : selectors.loginSection, Station.GrandCentral.Utilities.switchElement(selectors.loginSection + ', ' + selectors.recoverPasswordSection, section)
                }, _bindEvents = function () {
                    return cache.$togglePasswordRecovery.on('click', (function (e) {
                        e.preventDefault(), Station.GrandCentral.Utilities.switchElement(selectors.loginSection + ', ' + selectors.recoverPasswordSection, '#' + $(this).data('show-module-id'), 'animate-in fade-in-down')
                    }))
                }, $((function () {
                    Station.Theme.current.templateType === config.loginTemplate && init()
                })), {
                    init: init,
                    cacheElements: cacheElements,
                    renderRecoverPasswordSuccess: renderRecoverPasswordSuccess,
                    setInitialSection: setInitialSection
                }
            }(),
            Addresses: Addresses
        })
    }.call(void 0),
    function () {
        Station.Theme = Station.Theme || {}, Station.Theme.FeaturedProductSection = function ($) {
            return function (container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.FeaturedProductSection.prototype = Object.assign({}, Station.Theme.FeaturedProductSection.prototype, jQuery, {
            onLoad: function (evt) {
                Station.Theme.Currency.init(), Station.Theme.Cart.init()
            },
            onSelect: function (evt) {
                Station.Theme.FeaturedProduct.init(), Station.Theme.Base.initFitVids()
            }
        })
    }.call(void 0),
    function () {
        var $, _getBaseUnit, _initFancybox, _initInstanceOptionSelectors, _initJSVideoPlayers, _initVideoPlayers, _initYTVideoPlayers, _liveRegionText, _updateLiveRegion, cache, cacheElements, cacheInstance, classes, enableQtyLimit, getVariantBySelectors, init, initSection, initSections, instances, isOnBackorder, selectors, setAddToCartButtons, setBackorderNotice, setCompareAtPrice, setInstanceConfig, setQtyAvailable, setSale, setSelectAnOption, setSku, setSmartPaymentButtons, setVariant, themeConfig, ytPlayers;
        Station.Theme = Station.Theme || {}, Station.Theme.FeaturedProduct = ($ = jQuery.noConflict(), selectors = {
            sections: '.shopify-section-featured-product',
            addToCart: '.add-to-cart',
            basePrice: '[data-base-price]',
            backorderNotice: '.backorder-notice',
            currency: '[data-currency]',
            currencyCode: '[data-currency-code]',
            from: '.from',
            optionSelector: '[data-option-selector]',
            stickyCartOptionSelector: '.sticky-cart-option-selector',
            price: '[data-price]',
            priceCompareAt: '.compare-at',
            priceSell: '.sell-price',
            priceUnit: '.unit-price',
            priceUnitSeparator: '.unit-price-separator',
            priceUnitBaseUnit: '.unit-price-base-unit',
            qty: '.quantity',
            qtyAvailable: '[data-quantity-available]',
            saleSticker: '.sale-sticker',
            sku: '[data-sku]:not(option)',
            smartPaymentButtonContainer: '.smart-payment-button-container',
            variantID: 'input[name="id"]',
            productStatus: '[data-product-status]',
            masterContainerClass: '.shopify-section-featured-product',
            pmc: '.primary-media-container',
            pmt: '.primary-media-types',
            jsp: '.js-player',
            ytp: '.yt-player'
        }, classes = {
            image: 'image-container'
        }, Station.Theme.current, themeConfig = Station.Theme.config, instances = [], cache = {}, ytPlayers = {}, init = function () {
            return cacheElements(), initSections()
        }, cacheElements = function () {
            cache = {
                $sections: $(selectors.sections)
            }
        }, cacheInstance = function ($section) {
            var sectionId;
            return sectionId = $section.attr('id'), instances[sectionId].cache = {
                $addToCart: $section.find(selectors.addToCart),
                $basePrice: $section.find(selectors.basePrice),
                $backorderNotice: $section.find(selectors.backorderNotice),
                $currency: $section.find(selectors.currency),
                $currencyCode: $section.find(selectors.currencyCode),
                $from: $section.find(selectors.from),
                $optionSelector: $section.find(selectors.optionSelector),
                $stickyCartOptionSelector: $section.find(selectors.stickyCartOptionSelector),
                $price: $section.find(selectors.price),
                $priceCompareAt: $section.find(selectors.priceCompareAt),
                $priceSell: $section.find(selectors.priceSell),
                $priceUnit: $section.find(selectors.priceUnit),
                $priceUnitSeparator: $section.find(selectors.priceUnitSeparator),
                $priceUnitBaseUnit: $section.find(selectors.priceUnitBaseUnit),
                $qty: $section.find(selectors.qty),
                $qtyAvailable: $section.find(selectors.qtyAvailable),
                $saleSticker: $section.find(selectors.saleSticker),
                $sku: $section.find(selectors.sku),
                $smartPaymentButtonContainer: $(selectors.smartPaymentButtonContainer),
                $variantID: $section.find(selectors.variantID),
                $pmt: $section.find(selectors.pmt),
                $jsp: $section.find(selectors.jsp),
                $ytp: $section.find(selectors.ytp)
            }
        }, initSections = function () {
            cache.$sections.length && cache.$sections.each((function () {
                var $section;
                return $section = $(this), initSection($section)
            }))
        }, initSection = function ($section) {
            var sectionId, sectionIdPartial;
            return sectionIdPartial = (sectionId = $section.attr('id')).split('shopify-section-')[1], instances[sectionId] = {
                cache: null,
                config: null
            }, cacheInstance($section), setInstanceConfig($section), _initInstanceOptionSelectors($section), Station.Theme.ProductModel.init(sectionIdPartial), _initVideoPlayers($section), _initFancybox($section)
        }, setInstanceConfig = function ($section) {
            var sectionId, sectionIdPartial;
            return sectionIdPartial = (sectionId = $section.attr('id')).split('shopify-section-')[1], instances[sectionId].config = {
                currentProduct: getJsonFromScriptTag('#ProductJson-' + sectionIdPartial),
                inventory: getJsonFromScriptTag('#VariantsInventory-' + sectionIdPartial)
            }
        }, setVariant = function ($section, variant, deepLink) {
            var instance, reference_value, renderPrice, sectionId;
            sectionId = $section.attr('id'), instance = instances[sectionId], renderPrice = Station.Theme.Currency.renderPrice, variant ? (instance.cache.$variantID.val(variant.id), renderPrice(instance.cache.$priceSell.get(0), variant.price), variant.unit_price && variant.unit_price_measurement ? (reference_value = 1 !== variant.unit_price_measurement.reference_value ? variant.unit_price_measurement.reference_value : '', renderPrice(instance.cache.$priceUnit.get(0), variant.unit_price), instance.cache.$priceUnitBaseUnit.text(reference_value + variant.unit_price_measurement.reference_unit), instance.cache.$priceUnit.removeClass('hidden'), instance.cache.$priceUnitSeparator.removeClass('hidden'), instance.cache.$priceUnitBaseUnit.removeClass('hidden')) : (instance.cache.$priceUnit.addClass('hidden'), instance.cache.$priceUnitSeparator.addClass('hidden'), instance.cache.$priceUnitBaseUnit.addClass('hidden').text('')), renderPrice(instance.cache.$priceCompareAt.get(0), variant.compare_at_price), setCompareAtPrice(instance, null, variant.compare_at_price > variant.price), setQtyAvailable(instance, variant.inventory_quantity || instance.config.inventory[variant.id].quantity), setSku(instance, variant.sku), setSale(instance, variant), setBackorderNotice(instance, null, isOnBackorder(instance, variant)), setAddToCartButtons(instance, '', variant.available), setSmartPaymentButtons(instance, variant.available), themeConfig.product.enableQtyLimit && enableQtyLimit(instance, variant.inventory_quantity || instance.config.inventory[variant.id].quantity)) : (instance.cache.$variantID.val(''), renderPrice(instance.cache.$priceSell.get(0), Station.Theme.i18n.product.unavailable), renderPrice(instance.cache.$priceUnit.get(0), Station.Theme.i18n.product.unavailable), renderPrice(instance.cache.$priceCompareAt.get(0)), setCompareAtPrice(instance, null, !1), setQtyAvailable(instance, 0), setSku(instance, '', !1), setSale(instance, !1), setBackorderNotice(instance, null, !1), setAddToCartButtons(instance, Station.Theme.i18n.product.unavailable, !1), setSmartPaymentButtons(instance, !1), themeConfig.product.enableQtyLimit && enableQtyLimit(instance, 0, 0)), setSelectAnOption(instance), _updateLiveRegion($section)
        }, getVariantBySelectors = function (product, $optionSelector) {
            var options, variant, variants;
            return options = [], variant = null, variants = product.variants, $optionSelector.each((function () {
                var position;
                return position = parseInt($(this).data('option-number')), options.splice(position, 0, $('option:selected', this).text())
            })), $.each(variants, (function (i, e) {
                if (Station.GrandCentral.Utilities.arraysEqual(options, e.options)) return variant = e, !1
            })), variant
        }, setCompareAtPrice = function (instance, html, visible) {
            html && instance.cache.$priceCompareAt.html(html), !1 === visible ? instance.cache.$priceCompareAt.addClass('hidden') : instance.cache.$priceCompareAt.removeClass('hidden')
        }, setQtyAvailable = function (instance, qty, visible) {
            qty < 0 && (qty = 0), instance.cache.$qtyAvailable.text(qty), !1 === visible ? instance.cache.$qtyAvailable.parent().hide() : instance.cache.$qtyAvailable.parent().show()
        }, setSku = function (instance, sku, visible) {
            instance.cache.$sku.text(sku), !1 === visible ? instance.cache.$sku.parent().hide() : instance.cache.$sku.parent().show()
        }, setSale = function (instance, sale) {
            (sale = 'boolean' == typeof sale ? sale : sale.compare_at_price > sale.price) ? (instance.cache.$saleSticker.removeClass('hidden'), themeConfig.product.enableHighlightAddWhenSale && instance.cache.$addToCart.addClass('focus')) : (instance.cache.$saleSticker.addClass('hidden'), instance.cache.$addToCart.removeClass('focus'))
        }, setBackorderNotice = function (instance, html, visible) {
            html && instance.cache.$backorderNotice.html(html), !1 === visible ? instance.cache.$backorderNotice.addClass('hidden') : instance.cache.$backorderNotice.removeClass('hidden')
        }, isOnBackorder = function (instance, variant) {
            var inventory;
            return variant.inventory_policy && variant.inventory_quantity ? 'continue' === variant.inventory_policy && variant.inventory_quantity <= 0 : 'continue' === (inventory = instance.config.inventory[variant.id]).policy && inventory.quantity <= 0
        }, setAddToCartButtons = function (instance, text, enabled) {
            text || (text = enabled ? Station.Theme.i18n.product.addToCart : Station.Theme.i18n.product.soldOut), instance.cache.$addToCart.text(text), enabled ? instance.cache.$addToCart.prop('disabled', !1).removeClass('disabled') : instance.cache.$addToCart.prop('disabled', !0).addClass('disabled')
        }, setSmartPaymentButtons = function (instance, visible) {
            !1 === visible ? instance.cache.$smartPaymentButtonContainer.addClass('hidden') : instance.cache.$smartPaymentButtonContainer.removeClass('hidden')
        }, enableQtyLimit = function (instance, max, min) {
            min = min > 0 ? min : 1, max = max < 0 ? 0 : max, instance.cache.$qty.each((function () {
                var $this;
                return ($this = $(this)).attr('min', min), $this.attr('max', max), 0 === max && $this.removeAttr('max'), $this.on('change', (function () {
                    var val;
                    return min = parseInt($this.attr('min')), max = parseInt($this.attr('max')), val = parseInt($this.val()), 0 === max && (val = 0), val <= min && (val = min), val >= max && (val = max), $this.val(val)
                })), $(this).trigger('change')
            }))
        }, setSelectAnOption = function (instance) {
            instance.cache.$optionSelector.each((function () {
                var text;
                if (!$(this).val()) return text = $('option:selected', $(this)).text(), instance.cache.$priceSell.text(text), setAddToCartButtons(text), !1
            }))
        }, _initInstanceOptionSelectors = function ($section) {
            var instance, sectionId;
            sectionId = $section.attr('id'), (instance = instances[sectionId]).cache.$optionSelector.each((function () {
                return $(this).on('change', (function () {
                    var variant;
                    return variant = getVariantBySelectors(instance.config.currentProduct, instance.cache.$optionSelector), setVariant($section, variant, themeConfig.product.enableDeepLinking)
                }))
            }))
        }, _initVideoPlayers = function ($section) {
            var instance;
            return (instance = instances[$section.attr('id')]).cache.$jsp.length && Shopify.loadFeatures([{
                name: 'video-ui',
                version: '1.0',
                onLoad: _initJSVideoPlayers.bind(instance)
            }]), _initYTVideoPlayers.bind(instance)(), window.onYouTubeIframeAPIReady = _initYTVideoPlayers.bind(instance)
        }, _initJSVideoPlayers = function (errors) {
            errors || Shopify.Plyr && Shopify.Plyr.setup(this.cache.$jsp.toArray(), {
                loop: {
                    active: this.cache.$pmt.is('[data-loop="true"]')
                }
            })
        }, _initYTVideoPlayers = function () {
            var self;
            self = this, ('undefined' != typeof YT && null !== YT ? YT.Player : void 0) && $(selectors.ytp, this.cache.$pmt).each((function () {
                var id;
                id = $(this).attr('data-media-id'), ytPlayers[id] || (ytPlayers[id] = new YT.Player('media-' + id, {
                    events: {
                        onStateChange: function (event) {
                            0 === event.data && self.cache.$pmt.is('[data-loop="true"]') && event.target.seekTo(0)
                        }
                    }
                }))
            }))
        }, _initFancybox = function ($section) {
            $section.find(selectors.pmc + ':first-child').each((function () {
                var $this;
                if (($this = $(this)).hasClass(classes.image)) return $this.on('click', (function (e) {
                    var elements;
                    if (e.preventDefault(), Station.Theme.config.product.enableLightbox) return elements = $('a', $this), $.fancybox(elements)
                }))
            }))
        }, _updateLiveRegion = function ($section, variant) {
            var liveRegion;
            (liveRegion = $section.get(0).querySelector(selectors.productStatus)).textContent = _liveRegionText($section, variant), liveRegion.setAttribute('aria-hidden', !1), setTimeout((function () {
                liveRegion.setAttribute('aria-hidden', !0)
            }), 1e3)
        }, _liveRegionText = function ($section, variant) {
            var availability, inventory, liveRegionText, regularLabel, regularPrice, saleLabel, salePrice, unitLabel, unitPrice;
            return inventory = instances[$section.attr('id')].config.inventory, liveRegionText = '[Availability][Regular][$$][Sale][$]. [UnitPrice][$$$]', variant ? (availability = 0 === inventory[variant.id].quantity ? Station.Theme.i18n.product.soldOut + ', ' : '', liveRegionText = liveRegionText.replace('[Availability]', availability), regularLabel = '', regularPrice = Station.Theme.Currency.formatMoney(variant.price), saleLabel = '', salePrice = '', unitLabel = '', unitPrice = '', variant.compare_at_price > variant.price && (regularLabel = Station.Theme.i18n.product.regularPrice + ': ', regularPrice = Station.Theme.Currency.formatMoney(variant.compare_at_price) + ', ', saleLabel = Station.Theme.i18n.product.onSale + ': ', salePrice = Station.Theme.Currency.formatMoney(variant.price)), variant.unit_price && (unitLabel = Station.Theme.i18n.product.unitPrice, unitPrice = Station.Theme.Currency.formatMoney(variant.unit_price) + ' ' + Station.Theme.i18n.product.unitPriceSeparator + ' ' + _getBaseUnit(variant)), liveRegionText = liveRegionText.replace('[Regular]', regularLabel).replace('[$$]', regularPrice).replace('[Sale]', saleLabel).replace('[$]', salePrice).replace('[UnitPrice]', unitLabel).replace('[$$$]', unitPrice).trim()) : liveRegionText = Station.Theme.i18n.product.unavailable
        }, _getBaseUnit = function (variant) {
            return 1 === variant.unit_price_measurement.reference_value ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit
        }, $((function () {
            init()
        })), {
            init: init
        })
    }.call(void 0),
    function () {
        Station.Theme = Station.Theme || {}, Station.Theme.FooterSection = function ($) {
            return function (container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.FooterSection.prototype = Object.assign({}, Station.Theme.FooterSection.prototype, jQuery, {
            onSelect: function (evt) {
                Station.GrandCentral.Accordions.init(), Station.GrandCentral.NavSide.init(), Station.GrandCentral.Notify.init(), Station.GrandCentral.Tabs.init(), Station.Theme.Localization.init(), 'object' === ('undefined' == typeof twttr ? 'undefined' : _typeof(twttr)) && twttr.widgets.load()
            },
            onBlockSelect: function (evt) {
                Station.Theme.Currency.init()
            }
        })
    }.call(void 0),
    function () {
        var init, selectors;
        Station.Theme = Station.Theme || {}, Station.Theme.Form = (selectors = {
            statusMessage: '[data-form-status]'
        }, (init = function () {
            document.querySelectorAll(selectors.statusMessage).forEach((function (statusMessage) {
                statusMessage.setAttribute('tabindex', -1), statusMessage.focus(), statusMessage.addEventListener('blur', (function (evt) {
                    evt.target.removeAttribute('tabindex')
                }), {
                    once: !0
                })
            }))
        })(), {
            init: init
        })
    }.call(void 0),
    function () {
        Station.Theme = Station.Theme || {}, Station.Theme.HeaderSection = function ($) {
            return function (container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.HeaderSection.prototype = Object.assign({}, Station.Theme.HeaderSection.prototype, jQuery, {
            onSelect: function (evt) {
                Station.GrandCentral.NavPrimary.init(), Station.Theme.Base.init(), Station.Theme.PredictiveSearch.init()
            }
        })
    }.call(void 0),
    function () {
        var $, cache, cacheElements, init, selectors;
        Station.Theme = Station.Theme || {}, Station.Theme.Localization = ($ = jQuery.noConflict(), selectors = {
            form: '#localization_form',
            container: '.localization-container',
            toggle: '.localization-toggle',
            list: '.localization-list',
            option: '.localization-option',
            input: '.localization-input'
        }, cache = {}, cacheElements = function () {
            cache = {
                $form: $(selectors.form),
                $container: $(selectors.container),
                $toggle: $(selectors.toggle),
                $list: $(selectors.list)
            }
        }, init = function () {
            cacheElements(), cache.$container.length > 0 && (cache.$container.each((function () {
                var $container, $input, $list, $option, $toggle;
                $container = $(this), $toggle = $(selectors.toggle, this), $list = $(selectors.list, this), $option = $(selectors.option, this), $input = $(selectors.input, this), $toggle.on('click', (function (e) {
                    var expanded;
                    expanded = 'true' === $(this).attr('aria-expanded'), $list.toggleClass('expanded'), $toggle.attr('aria-expanded', !expanded)
                })), $option.on('click', (function (e) {
                    e.preventDefault(), $input.val($(this).data('value')), cache.$form.submit()
                })), $container.on('focusout', (function (e) {
                    0 === $(this).has(e.relatedTarget).length && ($list.removeClass('expanded'), $toggle.attr('aria-expanded', !1))
                })), $('body').on('click', (function (e) {
                    0 === $container.has(e.target).length && ($list.removeClass('expanded'), $toggle.attr('aria-expanded', !1))
                }))
            })), $(document).on('keyup', (function (e) {
                'Escape' === e.key && (cache.$list.removeClass('expanded'), cache.$toggle.attr('aria-expanded', !1))
            })))
        }, $((function () {
            init()
        })), {
            init: init
        })
    }.call(void 0),
    function () {
        Station.Theme = Station.Theme || {}, Station.Theme.MapSection = function ($) {
            return function (container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id'), this.$map = $('.google-map', this.$container)
            }
        }(jQuery.noConflict()), Station.Theme.MapSection.prototype = Object.assign({}, Station.Theme.MapSection.prototype, jQuery, {
            onUnload: function (evt) {
                void 0 !== window.google && google.maps.event.clearListeners(this.map, 'resize')
            },
            onSelect: function (evt) {
                Station.Theme.Map.loadMap(this.$map)
            }
        })
    }.call(void 0),
    function () {
        var $, cache, cacheElements, config, createMap, geolocate, init, loadMap, loadMaps, selectors, showMapError;
        Station.Theme = Station.Theme || {}, Station.Theme.Map = ($ = jQuery.noConflict(), selectors = {
            maps: '.google-map'
        }, Station.Theme.config, config = {
            i18n: Station.Theme.i18n,
            scriptURL: 'https://maps.googleapis.com/maps/api/js?key=',
            zoom: 14
        }, cache = {}, init = function () {
            cacheElements(), loadMaps()
        }, cacheElements = function () {
            cache = {
                $maps: $(selectors.maps)
            }
        }, createMap = function (map) {
            var $map;
            $map = $(map), cache.$currentMapContainer = $map, geolocate($map).then(function (results) {
                var center, mapOptions;
                mapOptions = {
                    zoom: config.zoom,
                    styles: config.styles,
                    center: results[0].geometry.location,
                    draggable: !1,
                    clickableIcons: !1,
                    scrollwheel: !1,
                    disableDoubleClickZoom: !0,
                    disableDefaultUI: !0
                }, map = new google.maps.Map($map[0], mapOptions), center = map.getCenter(), new google.maps.Marker({
                    map: map,
                    position: center
                }), google.maps.event.addDomListener(window, 'resize', (function () {
                    google.maps.event.trigger(map, 'resize'), map.setCenter(center)
                }))
            }.bind(this)).fail((function () {
                var errorMessage;
                switch (errorMessage = void 0, $map.geocoderStatus) {
                    case 'ZERO_RESULTS':
                        errorMessage = config.i18n.map.errors.addressNoResults;
                        break;
                    case 'OVER_QUERY_LIMIT':
                        errorMessage = config.i18n.map.errors.addressQueryLimitHTML;
                        break;
                    default:
                        errorMessage = config.i18n.map.errors.addressError
                }
                showMapError(errorMessage)
            }))
        }, geolocate = function ($map) {
            var address, deferred, geocoder;
            return deferred = $.Deferred(), geocoder = new google.maps.Geocoder, address = $map.data('address'), geocoder.geocode({
                address: address
            }, (function (results, status) {
                status !== google.maps.GeocoderStatus.OK && ($map.geocoderStatus = status, deferred.reject(status)), deferred.resolve(results)
            })), deferred
        }, loadMap = function (map) {
            var $map;
            ($map = $(map)).key = $map.data('api-key'), 'string' == typeof $map.key && '' !== $map.key && (0 === $('script[src*="' + $map.key + '&"]').length ? $.getScript(config.scriptURL + $map.key).then((function () {
                createMap(map)
            })) : createMap(map))
        }, loadMaps = function () {
            cache.$maps.each((function (i) {
                return loadMap(this)
            }))
        }, showMapError = function (errorMessage, $map) {
            var errorElement;
            $map || ($map = cache.$currentMapContainer), $map && (errorElement = '<div class="errors map-errors text-center">' + errorMessage + '</div>', $map.html(errorElement))
        }, window.gm_authFailure = function () {
            Shopify.designMode && showMapError(config.i18n.map.errors.authErrorHTML)
        }, $((function () {
            init()
        })), {
            init: init,
            cacheElements: cacheElements,
            loadMap: loadMap,
            loadMaps: loadMaps,
            showMapError: showMapError
        })
    }.call(void 0),
    function () {
        var $, Product, init, hasProp = {}.hasOwnProperty;
        Station.Theme = Station.Theme || {}, Station.Theme.Media = ($ = jQuery.noConflict(), Product = function () {
            var $container, _getVariant, _resetMedia, _setActiveMedia, _setActivePrimaryMedia, _setActiveSecondaryMedia, _setMediaConfig, _updateMedia, _zoom, cache, cacheElements, checkScreen, init, initJSVideoPlayers, initPrimaryMedia, initSecondaryMedia, initYTVideoPlayers, jsPlayers, mq, selectors, update, xrViewers, ytPlayers;
            return selectors = {
                pmt: '.primary-media-types',
                pmc: '.primary-media-container',
                pm: '.primary-media',
                smt: '.secondary-media-types',
                smc: '.secondary-media-container',
                sm: '.secondary-media',
                jsp: '.js-player',
                ytp: '.yt-player',
                xrv: '.xr-viewer'
            }, cache = {}, $container = null, mq = {}, checkScreen = function () {
                return mq = window.matchMedia('(max-width:' + Station.App.config.mediumScreen + 'px)')
            }, jsPlayers = [], initJSVideoPlayers = function () {
                Shopify.Plyr && (jsPlayers = Shopify.Plyr.setup(selectors.jsp, {
                    loop: {
                        active: cache.$pmt.is('[data-loop="true"]')
                    }
                }))
            }, ytPlayers = {}, initYTVideoPlayers = function () {
                ('undefined' != typeof YT && null !== YT ? YT.Player : void 0) && $(selectors.ytp, cache.$pmt).each((function () {
                    var id;
                    id = $(this).attr('data-media-id'), ytPlayers[id] || (ytPlayers[id] = new YT.Player('media-' + id, {
                        events: {
                            onStateChange: function (event) {
                                0 === event.data && cache.$pmt.is('[data-loop="true"]') && event.target.seekTo(0)
                            }
                        }
                    }))
                }))
            }, xrViewers = [], initPrimaryMedia = function () {
                var $pmc, $smc;
                $pmc = $(selectors.pmc + ':first-child'), $smc = $(selectors.smc, cache.$smt).eq(0), $pmc.each((function () {
                    var $this;
                    $this = $(this), _setActiveMedia($this, $smc), _setMediaConfig($this, $smc)
                }))
            }, initSecondaryMedia = function () {
                cache.$smcAll.each((function () {
                    var $pmc, $sma, $smc, id, variant;
                    $smc = $(this), $(selectors.sm, $smc), $sma = $('a', $smc).eq(0), id = $smc.attr('data-media-id'), $pmc = $(selectors.pmc + '[data-media-id="' + id + '"]'), variant = _getVariant(id), $sma.on('click', (function (e) {
                        var eventOptions;
                        e.preventDefault(), eventOptions = {
                            bubbles: !0,
                            cancelable: !0
                        }, $pmc.get(0).dispatchEvent(new CustomEvent('mediaVisible', eventOptions)), variant && Station.Theme.config.product.enableSetVariantFromSecondary ? (_setActiveSecondaryMedia($smc), Station.Theme.Product.setVariantByID(variant.id, Station.Theme.config.product.enableDeepLinking)) : _updateMedia($smc, !0, !0)
                    }))
                }))
            }, update = function (variant, container) {
                var $smc;
                $container = $(container), cacheElements(), variant ? ('string' != typeof variant && 'number' != typeof variant || (variant = Station.Theme.Product.getVariantByID(parseInt(variant))), 'object' === _typeof(variant) && variant.featured_media ? ($smc = $(selectors.smc + '[data-media-id="' + variant.featured_media.id + '"]')) && _updateMedia($smc) : _resetMedia()) : _resetMedia()
            }, init = function (container) {
                var ref, sectionId;
                $container = $(container), cacheElements(), checkScreen(), 'index' !== (ref = Station.Theme.current.templateType) && 'product' !== ref || (cache.$jsp.length && Shopify.loadFeatures([{
                    name: 'video-ui',
                    version: '1.0',
                    onLoad: initJSVideoPlayers
                }]), initYTVideoPlayers(), window.onYouTubeIframeAPIReady = initYTVideoPlayers, cache.$xrv.length && (sectionId = getSectionIdByName('main-product'), Station.Theme.ProductModel.init(sectionId)), initPrimaryMedia()), 'product' === Station.Theme.current.templateType && initSecondaryMedia()
            }, _getVariant = function (id) {
                var i, len, ref, variant;
                for (i = 0, len = (ref = Station.Theme.current.product.variants).length; i < len; i++)
                    if ((variant = ref[i]).featured_media && variant.featured_media.id && parseInt(variant.featured_media.id) === parseInt(id)) return variant
            }, _zoom = function ($e, src, alt) {
                $e && ($($e).trigger('zoom.destroy'), $e.zoom({
                    url: src,
                    touch: !1,
                    duration: 0,
                    callback: function () {
                        return this.setAttribute('alt', alt), this.naturalWidth <= $e.parent().width() ? $e.css('width', this.naturalWidth + 'px') : $e.css('width', 'initial'), this.naturalHeight <= $e.parent().height() ? $e.css('height', this.naturalHeight + 'px') : $e.css('height', 'initial')
                    }
                }))
            }, _setActivePrimaryMedia = function ($pmc) {
                cache.$pmcAll.length <= 1 || cache.$pmcAll.removeClass('active').hide(), $pmc.show().addClass('active')
            }, _setActiveSecondaryMedia = function ($smc) {
                0 !== cache.$smcAll.length && (cache.$smcAll.removeClass('active'), $smc.addClass('active'))
            }, _setActiveMedia = function ($pmc, $smc) {
                _setActivePrimaryMedia($pmc), _setActiveSecondaryMedia($smc)
            }, _setMediaConfig = function ($pmc, $smc, focus, autoplay) {
                var $pm, i, id, j, len, len1, player, type, viewer;
                switch ($pm = $(selectors.pm, $pmc), $pmc.hasClass('image-container') ? type = 'image' : $pmc.hasClass('video-container') ? type = 'video' : $pmc.hasClass('external-video-container') ? type = 'external_video' : $pmc.hasClass('model-container') && (type = 'model'), focus && $pmc.focus(), type) {
                    case 'image':
                        focus && $pm.closest('a').focus(), cache.$pmt.is('[is-zoomable]') && _zoom($pmc, $pm.attr('data-src-master'), $pm.attr('alt')), Station.Theme.config.product.enableLightbox && $pmc.on('click', (function (e) {
                            var elements, settings;
                            e.preventDefault(), cache.$smcAll.length ? (elements = $('a', cache.$smcAll), settings = {
                                index: cache.$smcAll.index($smc)
                            }) : elements = $('a', $pmc), $.fancybox(elements, settings)
                        }));
                        break;
                    case 'video':
                        if (autoplay)
                            for (i = 0, len = jsPlayers.length; i < len; i++) player = jsPlayers[i], $(player.elements.container).parent().hasClass('active') && player.play();
                        break;
                    case 'external_video':
                        id = $pmc.attr('data-media-id'), autoplay && ytPlayers[id] && ytPlayers[id].playVideo && ytPlayers[id].playVideo();
                        break;
                    case 'model':
                        if (autoplay)
                            for (j = 0, len1 = xrViewers.length; j < len1; j++) $((viewer = xrViewers[j]).container).parents('.model-container').hasClass('active') && viewer.play()
                }
            }, _updateMedia = function ($smc, focus, autoplay) {
                var $pmc, i, id, j, len, len1, player, viewer;
                if ($smc) {
                    if ($pmc = $(selectors.pmc + '[data-media-id="' + $smc.attr('data-media-id') + '"]'), jsPlayers.length > 0)
                        for (i = 0, len = jsPlayers.length; i < len; i++)(player = jsPlayers[i]).playing && player.pause();
                    if (Object.keys(ytPlayers).length > 0)
                        for (id in ytPlayers) hasProp.call(ytPlayers, id) && (player = ytPlayers[id]).getPlayerState && 1 === player.getPlayerState() && player.pauseVideo();
                    if (xrViewers.length > 0)
                        for (j = 0, len1 = xrViewers.length; j < len1; j++)(viewer = xrViewers[j]).interacting && viewer.pause();
                    _setActiveMedia($pmc, $smc), mq.matches && (autoplay = !1), _setMediaConfig($pmc, $smc, focus, autoplay)
                }
            }, _resetMedia = function () {
                var $smc, id;
                $smc = (id = Station.Theme.current.featured_media_id) ? $(selectors.smc + '[data-media-id="' + id + '"]') : $(cache.$smc).eq(0), _updateMedia($smc)
            }, {
                cacheElements: cacheElements = function () {
                    cache = {
                        $pmt: $container.find(selectors.pmt),
                        $pmcAll: $container.find(selectors.pmc),
                        $smt: $container.find(selectors.smt),
                        $smcAll: $container.find(selectors.smc),
                        $jsp: $container.find(selectors.jsp),
                        $xrv: $container.find(selectors.xrv)
                    }
                },
                initPrimaryMedia: initPrimaryMedia,
                initSecondaryMedia: initSecondaryMedia,
                update: update,
                init: init
            }
        }(), init = function (container) {
            Product.init(container)
        }, $((function () {
            var container, sectionId;
            (sectionId = getSectionIdByName('main-product')).length > 0 && (container = document.getElementById('shopify-section-' + sectionId), init(container))
        })), {
            Product: Product
        })
    }.call(void 0),
    function () {
        Station.Theme = Station.Theme || {}, Station.Theme.PasswordTemplateSection = function ($) {
            return function (container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.PasswordTemplateSection.prototype = Object.assign({}, Station.Theme.PasswordTemplateSection.prototype, jQuery, {
            onSelect: function (evt) {
                Station.Theme.Password.init()
            }
        })
    }.call(void 0),
    function () {
        var $, _bindEvents, cache, cacheElements, init, selectors, showPasswordEntry, showPasswordNotice;
        Station.Theme = Station.Theme || {}, Station.Theme.Password = ($ = jQuery.noConflict(), selectors = {
            page: 'html.password',
            pageModule: 'html.password .password-module',
            enterLink: 'html.password .enter-link',
            cancelEnterLink: 'html.password .cancel-enter-link',
            input: 'html.password input#password',
            emailInput: 'html.password input#email',
            moduleLogin: '#password-entry',
            moduleNotice: '#opening-soon'
        }, Station.Theme.config, cache = {}, init = function () {
            cacheElements(), _bindEvents(), 'password' === Station.Theme.current.templateType && ($('.errors', selectors.moduleLogin).length && showPasswordEntry(), cache.$enterLink.first().on('click', (function () {
                showPasswordEntry()
            })), cache.$cancelEnterLink.first().on('click', (function () {
                showPasswordNotice()
            })))
        }, showPasswordEntry = function () {
            Station.GrandCentral.Utilities.switchElement(selectors.pageModule, '#' + cache.$enterLink.data('show-module-id'), 'animate-in fade-in-down'), cache.$enterLink.hide(), cache.$cancelEnterLink.show(), cache.$input.focus(), cache.$page.css('overflow', 'hidden')
        }, showPasswordNotice = function () {
            Station.GrandCentral.Utilities.switchElement(selectors.pageModule, '#' + cache.$cancelEnterLink.data('show-module-id'), 'animate-in fade-in-down'), cache.$cancelEnterLink.hide(), cache.$enterLink.show(), cache.$emailInput.focus(), cache.$page.css('overflow', '')
        }, cacheElements = function () {
            cache = {
                $cancelEnterLink: $(selectors.cancelEnterLink),
                $enterLink: $(selectors.enterLink),
                $input: $(selectors.input),
                $emailInput: $(selectors.emailInput),
                $page: $(selectors.page)
            }
        }, _bindEvents = function () {
            $(document).keyup((function (e) {
                27 === e.keyCode && showPasswordNotice()
            }))
        }, $((function () {
            init()
        })), {
            init: init,
            cacheElements: cacheElements
        })
    }.call(void 0),
    function () {
        var $, ajax, cache, cacheElements, i18n, init, initSearch, selectors, shop;
        Station.Theme = Station.Theme || {}, Station.Theme.PredictiveSearch = ($ = jQuery.noConflict(), shop = Station.Theme.shop, i18n = Station.Theme.i18n.search, selectors = {
            meta: 'meta[name="predictive-search-unsupported"]',
            search: '.js-typeahead'
        }, cache = {}, cacheElements = function () {
            cache = {
                $meta: $(selectors.meta),
                $search: $(selectors.search)
            }
        }, init = function () {
            Station.Theme.config.search.enableSuggestions && (cacheElements(), 0 === cache.$meta.length && cache.$search.length > 0 && initSearch())
        }, ajax = function (type) {
            return {
                url: shop.root + 'search/suggest.json',
                path: 'resources.results.' + type,
                data: {
                    q: '{{query}}',
                    resources: {
                        type: 'product,collection,page,article',
                        limit: 5,
                        options: {
                            unavailable_products: Station.Theme.config.search.showUnavailableProducts,
                            fields: 'author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor'
                        }
                    }
                }
            }
        }, initSearch = function () {
            var _source;
            cache.$search.typeahead({
                minLength: 1,
                maxItem: 10,
                filter: !1,
                dynamic: !0,
                delay: 200,
                group: !0,
                backdrop: {
                    opacity: '0.2',
                    filter: 'alpha(opacity=20)',
                    'background-color': '#000'
                },
                backdropOnFocus: !0,
                searchOnFocus: !0,
                mustSelectItem: !Station.Theme.config.search.enterKeySubmit,
                href: '{{url}}',
                template: '<span class="image"><img src="{{featured_image.url}}" alt="{{title}}"/></span><span class="title">{{title}}</span>',
                emptyTemplate: '<p>'.concat(i18n.results.none, ' <var>{{query}}</var></p>'),
                source: (_source = {}, _defineProperty(_source, i18n.suggestions.products, {
                    ajax: ajax('products')
                }), _defineProperty(_source, i18n.suggestions.collections, {
                    ajax: ajax('collections')
                }), _defineProperty(_source, i18n.suggestions.pages, {
                    ajax: ajax('pages')
                }), _defineProperty(_source, i18n.suggestions.articles, {
                    ajax: ajax('articles')
                }), _source),
                callback: {
                    onLayoutBuiltBefore: function (node, query, result, html) {
                        var $price, $product, $vendor, entry, i, index, len;
                        if (0 === result.length) return html;
                        for ($('.image', html).each((function () {
                                var $image, src;
                                $image = $(this), '' !== (src = $('img', $image).attr('src')) && 'null' !== src || $image.remove()
                            })), index = i = 0, len = result.length; i < len; index = ++i) entry = result[index], ($product = $('[data-group="'.concat(i18n.suggestions.products, '"]'), html).filter('[data-index="'.concat(index, '"]'))).length > 0 && (Station.Theme.config.search.showVendor && ($vendor = $('<span>'.concat(entry.vendor, '</span>')).addClass('vendor'), $product.children('a').append($vendor)), Station.Theme.config.search.showPrice && ($price = $('<span></span>').addClass('price'), Station.Theme.Currency.renderPrice($price, entry.price.replace('.', '')), $product.children('a').append($price)));
                        return html.append('<li class="typeahead__search"><a href="'.concat(shop.root, 'search?q=').concat(query, '">').concat(i18n.results.show, ' <var>').concat(query, '</var></a></li>'))
                    },
                    onCancel: function () {
                        cache.$search.blur()
                    }
                }
            })
        }, $((function () {
            init()
        })), {
            init: init,
            initSearch: initSearch
        })
    }.call(void 0),
    function () {
        Station.Theme = Station.Theme || {}, Station.Theme.ProductTemplateSection = function ($) {
            return function (container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.ProductTemplateSection.prototype = Object.assign({}, Station.Theme.ProductTemplateSection.prototype, jQuery, {
            onSelect: function (evt) {
                var container;
                container = this.$container.closest('.shopify-section-product-template').get(0), Station.Theme.Base.init(), Station.Theme.Cart.init(), Station.Theme.Media.Product.init(container), Station.Theme.Product.init(container)
            }
        })
    }.call(void 0),
    function () {
        var $, _getBaseUnit, _initOptionSelectors, _initQtySync, _initSelectAnOption, _initVariant, _liveRegionText, _updateLiveRegion, cache, cacheElements, config, current, enableQtyLimit, getVariantByID, getVariantBySelectors, init, isOnBackorder, selectors, setAddToCartButtons, setBackorderNotice, setCompareAtPrice, setCurrentProduct, setQtyAvailable, setSale, setSelectAnOption, setSku, setSmartPaymentButtons, setVariant, setVariantByID, setVariantID, themeConfig, updatePickupAvailability;
        Station.Theme = Station.Theme || {}, Station.Theme.Product = ($ = jQuery.noConflict(), selectors = {
            addToCart: '.add-to-cart',
            basePrice: '[data-base-price]',
            backorderNotice: '.backorder-notice',
            currency: '[data-currency]',
            currencyCode: '[data-currency-code]',
            from: '.from',
            optionSelector: '[data-option-selector]',
            stickyCartOptionSelector: '.sticky-cart-option-selector',
            price: '[data-price]',
            priceCompareAt: '.compare-at',
            priceSell: '.sell-price',
            priceUnit: '.unit-price',
            priceUnitSeparator: '.unit-price-separator',
            priceUnitBaseUnit: '.unit-price-base-unit',
            qty: '.quantity',
            qtyAvailable: '[data-quantity-available]',
            saleSticker: '.sale-sticker',
            sku: '[data-sku]:not(option)',
            smartPaymentButtonContainer: '.smart-payment-button-container',
            variantID: 'input[name="id"]',
            productStatus: '[data-product-status]'
        }, current = Station.Theme.current, themeConfig = Station.Theme.config, config = {
            i18n: Station.Theme.i18n,
            currentCurrency: current.currency,
            currentProduct: current.product,
            currentVariant: current.variant,
            renderPrice: Station.Theme.Currency.renderPrice,
            formatMoney: Station.Theme.Currency.formatMoney,
            shop: Station.Theme.shop,
            templateType: current.templateType,
            utilities: Station.GrandCentral.Utilities
        }, cache = {}, init = function (container) {
            if (this.$container = $(container), this.isMainSection = this.$container.attr('id').includes('main-product'), this.sectionId = this.$container.attr('id').split('shopify-section-')[1], setCurrentProduct(this.sectionId), cacheElements(), 'product' === config.templateType && (_initOptionSelectors(), _initVariant(), _initSelectAnOption(), _initQtySync()), themeConfig.product.enableQtyLimit) return enableQtyLimit()
        }, setCurrentProduct = function (sectionId) {
            return config.currentProduct = getJsonFromScriptTag('#ProductJson-' + sectionId)
        }, cacheElements = function () {
            return cache = {
                $addToCart: this.$container.find(selectors.addToCart),
                $basePrice: this.$container.find(selectors.basePrice),
                $backorderNotice: this.$container.find(selectors.backorderNotice),
                $currency: this.$container.find(selectors.currency),
                $currencyCode: this.$container.find(selectors.currencyCode),
                $from: this.$container.find(selectors.from),
                $optionSelector: this.$container.find(selectors.optionSelector),
                $stickyCartOptionSelector: this.$container.find(selectors.stickyCartOptionSelector),
                $price: this.$container.find(selectors.price),
                $priceCompareAt: this.$container.find(selectors.priceCompareAt),
                $priceSell: this.$container.find(selectors.priceSell),
                $priceUnit: this.$container.find(selectors.priceUnit),
                $priceUnitSeparator: this.$container.find(selectors.priceUnitSeparator),
                $priceUnitBaseUnit: this.$container.find(selectors.priceUnitBaseUnit),
                $qty: this.$container.find(selectors.qty),
                $qtyAvailable: this.$container.find(selectors.qtyAvailable),
                $saleSticker: this.$container.find(selectors.saleSticker),
                $sku: this.$container.find(selectors.sku),
                $smartPaymentButtonContainer: $(selectors.smartPaymentButtonContainer),
                $variantID: this.$container.find(selectors.variantID)
            }
        }, getVariantByID = function (id) {
            var variant;
            return variant = null, $.each(config.currentProduct.variants, (function (i, e) {
                if (e.id === parseInt(id)) return variant = e, !1
            })), variant
        }, getVariantBySelectors = function (product, $optionSelector) {
            var options, variant, variants;
            return null == $optionSelector && ($optionSelector = cache.$optionSelector), options = [], variant = null, variants = product ? product.variants : config.currentProduct.variants, $optionSelector.each((function () {
                var position;
                return position = parseInt($(this).data('option-number')), options.splice(position, 0, $('option:selected', this).text())
            })), $.each(variants, (function (i, e) {
                if (Station.GrandCentral.Utilities.arraysEqual(options, e.options)) return variant = e, !1
            })), variant
        }, isOnBackorder = function (variant) {
            var inventory;
            return variant.inventory_policy && variant.inventory_quantity ? 'continue' === variant.inventory_policy && variant.inventory_quantity <= 0 : 'continue' === (inventory = current.inventory[variant.id]).policy && inventory.quantity <= 0
        }, enableQtyLimit = function (max, min) {
            min = min > 0 ? min : 1, max = max < 0 ? 0 : max, cache.$qty.each((function () {
                var $this;
                return ($this = $(this)).attr('min', min), $this.attr('max', max), 0 === max && $this.removeAttr('max'), $this.on('change', (function () {
                    var val;
                    return min = parseInt($this.attr('min')), max = parseInt($this.attr('max')), val = parseInt($this.val()), 0 === max && (val = 0), val <= min && (val = min), val >= max && (val = max), $this.val(val)
                })), $(this).trigger('change')
            }))
        }, setAddToCartButtons = function (text, enabled) {
            text || (text = enabled ? config.i18n.product.addToCart : config.i18n.product.soldOut), cache.$addToCart.text(text), enabled ? cache.$addToCart.prop('disabled', !1).removeClass('disabled') : cache.$addToCart.prop('disabled', !0).addClass('disabled')
          //添加协议后禁用按钮
              !function () {
    if ($('#productCheckInput').length > 0) {
        const addToCart = $('.mainAddToCart')
        addToCart.attr("disabled", "true");
        // addToCart.addClass("disabled");
    }
    $('#productCheckInput').change(function checkChange(e) {
      const addToCart = $('.mainAddToCart')
        const event = e || window.event
        if (event.target.checked) {
            if (!(addToCart.attr('aria-disabled') == 'true')) {
    $('.productCheckInputTips').css("display","none")
                addToCart.removeAttr("disabled");
                // addToCart.removeClass("disabled");
        addToCart.css("pointer-events","auto");
            }
        } else {
    $('.productCheckInputTips').css("display","block")
          
            addToCart.attr("disabled", "true");
            // addToCart.addClass("disabled");
        addToCart.css("pointer-events","none");
        }
    })
              //详情页本地提货折扣码展示
              $('#localPickupInput').change(function checkChange(e) {
        const event = e || window.event
        if (event.target.checked) {
    $('.localPickupInputCode').css("opacity",1)
        } else {
    $('.localPickupInputCode').css("opacity",0)
        }
    })
}()
        }, setSmartPaymentButtons = function (visible) {
            !1 === visible ? cache.$smartPaymentButtonContainer.addClass('hidden') : cache.$smartPaymentButtonContainer.removeClass('hidden')
        }, setBackorderNotice = function (html, visible) {
            html && cache.$backorderNotice.html(html), !1 === visible ? cache.$backorderNotice.addClass('hidden') : cache.$backorderNotice.removeClass('hidden')
        }, setCompareAtPrice = function (html, visible) {
            html && cache.$priceCompareAt.html(html), !1 === visible ? cache.$priceCompareAt.addClass('hidden') : cache.$priceCompareAt.removeClass('hidden')
        }, setQtyAvailable = function (qty, visible) {
            qty < 0 && (qty = 0), cache.$qtyAvailable.text(qty), !1 === visible ? cache.$qtyAvailable.parent().hide() : cache.$qtyAvailable.parent().show()
        }, setSale = function (sale) {
            (sale = 'boolean' == typeof sale ? sale : sale.compare_at_price > sale.price) ? (cache.$saleSticker.removeClass('hidden'), themeConfig.product.enableHighlightAddWhenSale && cache.$addToCart.addClass('focus')) : (cache.$saleSticker.addClass('hidden'), cache.$addToCart.removeClass('focus'))
        }, setSelectAnOption = function () {
            cache.$optionSelector.each((function () {
                var text;
                if (!$(this).val()) return text = $('option:selected', $(this)).text(), cache.$priceSell.text(text), setAddToCartButtons(text), !1
            }))
        }, setSku = function (sku, visible) {
            cache.$sku.text(sku), !1 === visible ? cache.$sku.parent().hide() : cache.$sku.parent().show()
        }, setVariant = function (variant, deepLink) {
            var reference_value;
            variant ? (current.variant = variant, setVariantID(), config.renderPrice(selectors.priceSell, variant.price), variant.unit_price && variant.unit_price_measurement ? (reference_value = 1 !== variant.unit_price_measurement.reference_value ? variant.unit_price_measurement.reference_value : '', config.renderPrice(selectors.priceUnit, variant.unit_price), cache.$priceUnitBaseUnit.text(reference_value + variant.unit_price_measurement.reference_unit), cache.$priceUnit.removeClass('hidden'), cache.$priceUnitSeparator.removeClass('hidden'), cache.$priceUnitBaseUnit.removeClass('hidden')) : (cache.$priceUnit.addClass('hidden'), cache.$priceUnitSeparator.addClass('hidden'), cache.$priceUnitBaseUnit.addClass('hidden').text('')), config.renderPrice(selectors.priceCompareAt, variant.compare_at_price), setCompareAtPrice(null, variant.compare_at_price > variant.price), setQtyAvailable(variant.inventory_quantity || current.inventory[variant.id].quantity), setSku(variant.sku), setSale(variant), setBackorderNotice(null, isOnBackorder(variant)), setAddToCartButtons('', variant.available), setSmartPaymentButtons(variant.available), Station.Theme.Media.Product.update(variant.id, this.$container.get(0)), themeConfig.product.enableQtyLimit && enableQtyLimit(variant.inventory_quantity || current.inventory[variant.id].quantity), deepLink && config.utilities.setParam('variant', variant.id), updatePickupAvailability(variant.id)) : (current.variant = null, setVariantID(), config.renderPrice(selectors.priceSell, config.i18n.product.unavailable), config.renderPrice(selectors.priceUnit, config.i18n.product.unavailable), config.renderPrice(selectors.priceCompareAt), setCompareAtPrice(null, !1), setQtyAvailable(0), setSku('', !1), setSale(!1), setBackorderNotice(null, !1), setAddToCartButtons(config.i18n.product.unavailable, !1), setSmartPaymentButtons(!1), Station.Theme.Media.Product.update(null, this.$container.get(0)), themeConfig.product.enableQtyLimit && enableQtyLimit(0, 0), updatePickupAvailability()), setSelectAnOption(), _updateLiveRegion(variant)
        }, setVariantID = function (id, $element) {
            id || (id = null !== current.variant ? current.variant.id : ''), $element || ($element = cache.$variantID), $element.val(id)
        }, setVariantByID = function (id, deepLink) {
            var variant;
            id && (variant = getVariantByID(id)) && (cache.$optionSelector.each((function (index, value) {
                $(this).val(variant['option' + (index + 1)])
            })), cache.$stickyCartOptionSelector.each((function (index, value) {
                $(this).val(variant['option' + (index + 1)])
            })), setVariant(variant, deepLink))
        }, updatePickupAvailability = function (id) {
            var pickUpAvailability;
            (pickUpAvailability = document.querySelector('pickup-availability')) && ('function' == typeof pickUpAvailability.fetchAvailability && id ? pickUpAvailability.fetchAvailability(id) : (pickUpAvailability.removeAttribute('available'), pickUpAvailability.innerHTML = ''))
        }, _initOptionSelectors = function () {
            cache.$optionSelector.each((function () {
                return $(this).on('change', (function () {
                    var variant;
                    return cache.$stickyCartOptionSelector.filter('[data-option-number=' + $(this).data('option-number') + ']').val($(this).val()), variant = getVariantBySelectors(config.currentProduct, cache.$optionSelector), setVariant(variant, themeConfig.product.enableDeepLinking)
                }))
            })), cache.$stickyCartOptionSelector.each((function () {
                return $(this).on('change', (function () {
                    var sync;
                    return (sync = cache.$optionSelector.filter('[data-option-number=' + $(this).data('option-number') + ']')).val($(this).val()), sync.trigger('change')
                }))
            }))
        }, _initSelectAnOption = function () {
            themeConfig.product.enableSelectAnOption && (cache.$optionSelector.each((function (index, value) {
                var $selectedOption, optionName;
                return null == (optionName = $(this).data('select-text')) && (optionName = currentProduct.options[index]), $selectedOption = '<option value="">' + optionName + '</option>', $(this).prepend($selectedOption).val('')
            })), cache.$optionSelector.first().trigger('change'))
        }, _initVariant = function () {
            var variantID;
            (variantID = Station.GrandCentral.Utilities.getParam('variant')) && (config.currentVariant = getVariantByID(variantID)), setVariant(config.currentVariant, !1), themeConfig.product.showPrimaryImageFirst && !variantID && Station.Theme.Media.Product.update(null, this.$container.get(0))
        }, _initQtySync = function () {
            cache.$qty.each((function () {
                return $(this).on('change', (function () {
                    return cache.$qty.val($(this).val())
                }))
            }))
        }, _liveRegionText = function (variant) {
            var availability, liveRegionText, regularLabel, regularPrice, saleLabel, salePrice, unitLabel, unitPrice;
            return liveRegionText = '[Availability][Regular][$$][Sale][$]. [UnitPrice][$$$]', variant ? (availability = 0 === current.inventory[variant.id].quantity ? config.i18n.product.soldOut + ', ' : '', liveRegionText = liveRegionText.replace('[Availability]', availability), regularLabel = '', regularPrice = config.formatMoney(variant.price), saleLabel = '', salePrice = '', unitLabel = '', unitPrice = '', variant.compare_at_price > variant.price && (regularLabel = config.i18n.product.regularPrice + ': ', regularPrice = config.formatMoney(variant.compare_at_price) + ', ', saleLabel = config.i18n.product.onSale + ': ', salePrice = config.formatMoney(variant.price)), variant.unit_price && (unitLabel = config.i18n.product.unitPrice, unitPrice = config.formatMoney(variant.unit_price) + ' ' + config.i18n.product.unitPriceSeparator + ' ' + _getBaseUnit(variant)), liveRegionText = liveRegionText.replace('[Regular]', regularLabel).replace('[$$]', regularPrice).replace('[Sale]', saleLabel).replace('[$]', salePrice).replace('[UnitPrice]', unitLabel).replace('[$$$]', unitPrice).trim()) : liveRegionText = config.i18n.product.unavailable
        }, _updateLiveRegion = function (variant) {
            var liveRegion;
            (liveRegion = this.$container.get(0).querySelector(selectors.productStatus)).textContent = _liveRegionText(variant), liveRegion.setAttribute('aria-hidden', !1), setTimeout((function () {
                liveRegion.setAttribute('aria-hidden', !0)
            }), 1e3)
        }, _getBaseUnit = function (variant) {
            return 1 === variant.unit_price_measurement.reference_value ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit
        }, $((function () {
            var container, sectionId;
            (sectionId = getSectionIdByName('main-product')).length > 0 && (container = document.getElementById('shopify-section-' + sectionId), init(container))
        })), {
            init: init,
            cacheElements: cacheElements,
            getVariantByID: getVariantByID,
            getVariantBySelectors: getVariantBySelectors,
            isOnBackorder: isOnBackorder,
            enableQtyLimit: enableQtyLimit,
            setAddToCartButtons: setAddToCartButtons,
            setBackorderNotice: setBackorderNotice,
            setCompareAtPrice: setCompareAtPrice,
            setQtyAvailable: setQtyAvailable,
            setSale: setSale,
            setSelectAnOption: setSelectAnOption,
            setSku: setSku,
            setVariant: setVariant,
            setVariantByID: setVariantByID
        })
    }.call(void 0),
    function () {
        var $;
        window.Station.Theme = window.Station.Theme || {}, Station.Theme.Sections = function () {
            var $;
            $ = jQuery, this.constructors = {}, this.instances = [], $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this))
        }, jQuery.noConflict()((function () {
            var sections;
            (sections = new Station.Theme.Sections).register('collection', Station.Theme.CollectionSection), sections.register('collection-list', Station.Theme.CollectionListSection), sections.register('collection-template', Station.Theme.CollectionTemplateSection), sections.register('featured-product', Station.Theme.FeaturedProductSection), sections.register('footer', Station.Theme.FooterSection), sections.register('header', Station.Theme.HeaderSection), sections.register('map', Station.Theme.MapSection), sections.register('password-template', Station.Theme.PasswordTemplateSection), sections.register('product-template', Station.Theme.ProductTemplateSection), sections.register('sidebar', Station.Theme.SidebarSection), sections.register('slideshow', Station.Theme.SlideshowSection), sections.register('video', Station.Theme.VideoSection)
        })), Station.Theme.Sections.prototype = Object.assign({}, Station.Theme.Sections.prototype, $ = jQuery, {
            _createInstance: function (container, constructor) {
                var $container, id, instance, type;
                if (id = ($container = $(container)).attr('data-section-id'), type = $container.attr('data-section-type'), null != (constructor = constructor || this.constructors[type])) return instance = Object.assign(new constructor(container), {
                    id: id,
                    type: type,
                    container: container
                }), this.instances.push(instance), instance
            },
            _onSectionLoad: function (evt) {
                var container, instance;
                (container = $('[data-section-id]', evt.target)[0]) && null != (instance = this._createInstance(container)) && 'function' == typeof instance.onLoad && instance.onLoad(evt)
            },
            _onSectionUnload: function (evt) {
                this.instances = this.instances.filter((function (instance) {
                    var isEventInstance;
                    return (isEventInstance = instance.id === evt.detail.sectionId) && 'function' == typeof instance.onUnload && instance.onUnload(evt), !isEventInstance
                }))
            },
            _onSelect: function (evt) {
                var instance;
                null != (instance = this.instances.find((function (instance) {
                    return instance.id === evt.detail.sectionId
                }))) && 'function' == typeof instance.onSelect && instance.onSelect(evt)
            },
            _onDeselect: function (evt) {
                var instance;
                null != (instance = this.instances.find((function (instance) {
                    return instance.id === evt.detail.sectionId
                }))) && 'function' == typeof instance.onDeselect && instance.onDeselect(evt)
            },
            _onBlockSelect: function (evt) {
                var instance;
                null != (instance = this.instances.find((function (instance) {
                    return instance.id === evt.detail.sectionId
                }))) && 'function' == typeof instance.onBlockSelect && instance.onBlockSelect(evt)
            },
            _onBlockDeselect: function (evt) {
                var instance;
                null != (instance = this.instances.find((function (instance) {
                    return instance.id === evt.detail.sectionId
                }))) && 'function' == typeof instance.onBlockDeselect && instance.onBlockDeselect(evt)
            },
            register: function (type, constructor) {
                this.constructors[type] = constructor, $('[data-section-type=' + type + ']').each(function (index, container) {
                    this._createInstance(container, constructor)
                }.bind(this))
            }
        })
    }.call(void 0),
    function () {
        Station.Theme = Station.Theme || {}, Station.Theme.SidebarSection = function ($) {
            return function (container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.SidebarSection.prototype = Object.assign({}, Station.Theme.SidebarSection.prototype, jQuery, {
            onSelect: function (evt) {
                Station.GrandCentral.Accordions.init(), Station.GrandCentral.NavSide.init(), Station.GrandCentral.Notify.init(), Station.GrandCentral.Tabs.init(), 'object' === ('undefined' == typeof twttr ? 'undefined' : _typeof(twttr)) && twttr.widgets.load()
            },
            onBlockSelect: function (evt) {
                Station.Theme.Currency.init()
            }
        })
    }.call(void 0),
    function () {
        var $;
        Station.Theme = Station.Theme || {}, Station.Theme.SlideshowSection = function ($) {
            return function (container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id'), this.carousel = '#gc-carousel-' + this.sectionId, this.$carousel = $(this.carousel)
            }
        }(jQuery.noConflict()), Station.Theme.SlideshowSection.prototype = Object.assign({}, Station.Theme.SlideshowSection.prototype, $ = jQuery, {
            onLoad: function (evt) {
                Station.Theme.Slideshow.init(), Station.GrandCentral.Vendor.Flickity.initCarousel(this.$carousel)
            },
            onSelect: function (evt) {
                Station.Theme.Slideshow.init(), Station.GrandCentral.Vendor.Flickity.initCarousel(this.$carousel), Station.Theme.SlideShowHeights.setSectionId(this.sectionId), Station.Theme.SlideShowHeights.refresh(), Flickity.data('#gc-carousel-' + this.sectionId).resize()
            },
            onBlockSelect: function (evt) {
                var $cells, $selectedCell, $selectedCellIndex;
                this.$carousel, $cells = $('.section-block', this.$carousel), $selectedCell = $('*[data-block-id="' + evt.detail.blockId + '"]', this.$carousel), $selectedCellIndex = $cells.index($selectedCell), Station.Theme.Slideshow.init(), Station.GrandCentral.Vendor.Flickity.initCarousel(this.$carousel), this.$carousel.flickity('pausePlayer').flickity('select', $selectedCellIndex)
            },
            onBlockDeselect: function () {
                Station.Theme.SlideShowHeights.setSectionId(this.sectionId), Station.Theme.SlideShowHeights.refresh(), Flickity.data('#gc-carousel-' + this.sectionId).reloadCells()
            }
        })
    }.call(void 0),
    function () {
        var $, cache, cacheElements, destroyDefaultHeights, init, initVideoPlayers, selectors;
        Station.Theme = Station.Theme || {}, Station.Theme.Slideshow = ($ = jQuery.noConflict(), Station.Theme.current.players, selectors = {
            sections: '.section-slideshow',
            youtube: '.flickity-slider .external-video.youtube',
            vimeo: '.flickity-slider .external-video.vimeo'
        }, cache = {}, cacheElements = function () {
            cache = {
                $youtube: $(selectors.youtube),
                $vimeo: $(selectors.vimeo),
                $sections: $(selectors.sections)
            }
        }, init = function () {
            cacheElements(), initVideoPlayers(), destroyDefaultHeights()
        }, initVideoPlayers = function () {
            ('undefined' != typeof YT && null !== YT ? YT.Player : void 0) && cache.$youtube.each((function (index, video) {
                Station.Theme.current.players.youtube[video.id] || (Station.Theme.current.players.youtube[video.id] = new YT.Player(video.id))
            })), ('undefined' != typeof Vimeo && null !== Vimeo ? Vimeo.Player : void 0) && cache.$vimeo.each((function (index, video) {
                Station.Theme.current.players.vimeo[video.id] || (Station.Theme.current.players.vimeo[video.id] = new Vimeo.Player(video))
            }))
        }, destroyDefaultHeights = function () {
            if (!Shopify.designMode) return cache.$sections.each((function () {}))
        }, $((function () {
            init()
        })), {
            init: init,
            initVideoPlayers: initVideoPlayers
        })
    }.call(void 0),
    function () {
        Station.Theme = Station.Theme || {}, Station.Theme.VideoSection = function ($) {
            return function (container) {
                this.$container = $(container), this.sectionId = this.$container.attr('data-section-id')
            }
        }(jQuery.noConflict()), Station.Theme.VideoSection.prototype = Object.assign({}, Station.Theme.VideoSection.prototype, jQuery, {
            onLoad: function (evt) {
                Station.Theme.Base.initFitVids()
            },
            onSelect: function (evt) {
                Station.Theme.Base.initFitVids()
            }
        })
    }.call(void 0);

$('.QAQ').click(function () {
    $('.QAA-content').css("max-height", "0")
    if ($(this).attr("active") == "false") {
        $('.QAQ').not(this).attr("active", "false")
        $(this).attr("active", "true")
        $('.QALogo').css("transform", "rotate(0deg)")
        $($(this).find('.QALogo')).css("transform", "rotate(90deg)")
        $(this).next().css("max-height", "200px")
    } else {
        $(this).attr("active", "false")
        $($(this).find('.QALogo')).css("transform", "rotate(0deg)")
    }

})
let specialTag = $('.content-detail')

const scrollEvent = function () {
    $('.tab-detail-content-one').removeClass("tab-detail-content-one-show")
    for (let i = specialTag.length - 1; i >= 0; i--) {
        if ($(window).scrollTop() > $(specialTag[i]).offset().top - 150) {
            $($('.tab-detail-content-one')[i]).addClass("tab-detail-content-one-show")
            return
        }
    }
}
window.addEventListener("scroll", scrollEvent)
let specialInterval
$('.tab-detail-content-one').click(function () {
    $('html,body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 80
    }, 500);
    window.removeEventListener("scroll", scrollEvent);
    clearTimeout(specialInterval)
    specialInterval = setTimeout(() => {
        $('.tab-detail-content-one').removeClass("tab-detail-content-one-show")
        $(this).addClass("tab-detail-content-one-show")
        window.addEventListener("scroll", scrollEvent)

    }, 500)
    // return false;
});
$('.yuan').click(function () {
    if ($(this).prev()[0].paused) {

        $(this).css("opacity", "0")
        $(this).prev().trigger('play')
    } else {
        $(this).css("opacity", "1")
        $(this).prev().trigger('pause')
    }

})
$('.content-detail-video-video').click(function () {
    if ($(this)[0].paused) {
        $($(this).next()).css("opacity", "0")
    } else {
        $($(this).next()).css("opacity", "1")
    }

});
!function () {
    const productSvg = document.querySelectorAll('.productSvg')
    const productImg = document.querySelectorAll('.productImg')
    const moveBox = document.querySelector('.moveBox')
    const wideBox = document.querySelector('.wideBox')
    const maxBox = document.querySelector('.maxBox')
    const productLine = document.querySelector('.productLine')
    if (wideBox && moveBox) {
        wideBox.style.height = (maxBox.offsetHeight + 80) + 'px';
        window.addEventListener("resize", function () {
            wideBox.style.height = (maxBox.offsetHeight + 80) + 'px';
        })
        let time = 0
        let a
        const jjj = () => {
            a = window.setInterval(() => {
                time++
                for (let i = 0; i < 5; i++) {
                    productImg[i].style.transform = 'scale(1)'
                }

                if (time == 5) {
                    productLine.style.transition = 'all 0s'
                    maxBox.style.transition = 'all 0s'
                    productLine.style.left = '-20%'
                    maxBox.style.left = '0'
                    setTimeout(() => {
                        productLine.style.transition = 'all .5s'
                        maxBox.style.transition = 'all .5s'
                        productLine.style.left = '0'
                        maxBox.style.left = '-100%'

                    }, 10)
                    time = 0
                    productImg[time].style.transform = 'scale(1.2)'
                } else {
                    productLine.style.left = 20 * time + '%'
                    maxBox.style.left = '-' + 100 * (time + 1) + '%'
                    productImg[time].style.transform = 'scale(1.2)'
                }

            }, 10000)
        }
        jjj()
        moveBox.onmouseover = () => {
            clearInterval(a)
        }
        moveBox.onmouseout = () => {
            jjj()
        }
        for (let i = 0; i < 5; i++) {
            productSvg[i].onmouseover = () => {
                for (let i = 0; i < 5; i++) {
                    productImg[i].style.transform = 'scale(1)'
                }
                time = i
                productLine.style.left = 20 * i + '%'
                productImg[i].style.transform = 'scale(1.2)'
                maxBox.style.left = '-' + 100 * (i + 1) + '%'
            }
        }
    }


}()

!function () {
    const div = $('.full-content-blog-detail')
    let arr = []
    for (let i = 0; i < div.length; i++) {
        arr.push($(div[i]).height())
    }
    arr.sort((a, b) => b - a)
    div.height(arr[0])
    window.onresize = () => {
        div.height('')
        let arr = []
        for (let i = 0; i < div.length; i++) {
            arr.push($(div[i]).height())
        }
        arr.sort((a, b) => b - a)
        div.height(arr[0])
    }
}()
  !function () {
    const div = $('.group-collections-product')
    window.onresize = () => {
        div.height('')
        let arr = []
        for (let i = 0; i < div.length; i++) {
            arr.push($(div[i]).height())
        }
        arr.sort((a, b) => b - a)
        div.height(arr[0]+'px')
    }
}()
  !function(){
    const clickToggle=$('.clickToToggleModel')
    const toggleSvg=$('.toggleModel-svg')
    const toggleContain=$('.toggleModel-contain')
    clickToggle.click(()=>{
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      document.body.style.cssText += 'position:fixed;width:100%;top:-' + scrollTop + 'px;';
    toggleContain.show()
      
    })
    toggleSvg.click(()=>{
      let body = document.body;
      body.style.position = '';
      let top = body.style.top;
      document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top);
      body.style.top = '';
    toggleContain.hide()
    
    })
    }()
!function(){
  let divs = document.querySelectorAll(".divs");

for (let i = 0; i < divs.length; i++) {
divs[i].href = divs[i].href.slice(divs[i].href.indexOf("http", 4)==-1?0:divs[i].href.indexOf("http", 4), divs[i].href.length);
}
}()
!function(){
     let dataArr=[]
    let mainArr=[]
    if(mainArr.length==0){
       mainArr.push({
      id:$(".thisItem").attr("id"),
        image:$(".thisItem").attr("image"),
        quantity:1,
        title:$(".thisItem").attr("title")
    })
    }
            showMain(mainArr)  
        
    $(".product-bundle-left .bundleReduce").click(function(){
      if($(this).next().val()>1){
            $(this).next().val($(this).next().val()-1)  
            mainArr.forEach((item,index)=>{
              if(item.id==$(this).attr("id")){
              item.quantity=item.quantity-1
              }
            })
            showMain(mainArr)       
         }
    })
    $(".product-bundle-left .bundleAdd").click(function(){
           $(this).prev().val(+$(this).prev().val()+1)  
            mainArr.forEach((item,index)=>{
              if(item.id==$(this).attr("id")){
              item.quantity= +item.quantity+1
              }
            })
            showMain(mainArr)   
              })
        $(".product-bundle-left .bundleQuantity").change(function(){
          if($(this).val()>0){
            mainArr.forEach((item,index)=>{
              if(item.id==$(this).attr("id")){
              item.quantity=$(this).val()
              }
            })
            showMain(mainArr)
          }else{
           $(this).val(1)  
            mainArr[0].quantity=1
            showMain(mainArr)
          }
        })
    function showMain(data){
      let src=''
      data.forEach(item=>{
        src += `
        <div class=" bundle-total-left"> 
        <img  src="${item.image}" >
        </div>
        <div class=" bundle-total-center">This Item</div>
        <div class=" bundle-total-right">x${item.quantity}</div>
        `
      })
      $('.thisItem').html(src)
    }
    $(".product-bundle-center .bundle-button").click(function(){
      dataArr.unshift({
        id:$(this).attr("id"),
        image:$(this).attr("image"),
        quantity:1,
        title:$(this).attr("title")
      })
      $(this).parent().find('.bundleQuantity').val(1)
     $(this).parents(".bundleProduct").addClass("bundle-selected")
      showData(dataArr)
    })
    function showData(data){
      let src=''
      data.forEach(item=>{
        src += `
        <div class="bundle-total-product">
        <div class=" bundle-total-left"> 
        <img  src="${item.image}" >
        </div>
        <div class=" bundle-total-center">${item.title}</div>
        <div class=" bundle-total-right">x${item.quantity}</div>
      </div>
        `
      })
      $('.add-new-bundle').html(src)
    }
    $(".product-bundle-center .bundleReduce").click(function(){
      if($(this).next().val()>1){
            $(this).next().val($(this).next().val()-1)  
            dataArr.forEach((item,index)=>{
              if(item.id==$(this).attr("id")){
              item.quantity=item.quantity-1
              }
            })
             let arr=JSON.parse(JSON.stringify(dataArr))
          arr=arr.filter(item=>item.id==$(this).attr("id"))
          dataArr=dataArr.filter(item=>item.id!=$(this).attr("id"))
            dataArr.unshift(...arr)
            showData(dataArr)       
         }else{
            dataArr=dataArr.filter(item=>item.id!=$(this).attr("id"))
            showData(dataArr)
          $(this).parents(".bundleProduct").removeClass("bundle-selected")
         }
    })
    $(".product-bundle-center .bundleAdd").click(function(){
           $(this).prev().val(+$(this).prev().val()+1)  
            dataArr.forEach((item,index)=>{
              if(item.id==$(this).attr("id")){
              item.quantity= +item.quantity+1
              }
            })
          let arr=JSON.parse(JSON.stringify(dataArr))
          arr=arr.filter(item=>item.id==$(this).attr("id"))
          dataArr=dataArr.filter(item=>item.id!=$(this).attr("id"))
            dataArr.unshift(...arr)
            showData(dataArr)   
              })
        $(".product-bundle-center .bundleQuantity").change(function(){
          if($(this).val()>0){
            dataArr.forEach((item,index)=>{
              if(item.id==$(this).attr("id")){
              item.quantity=$(this).val()
              }
            })
          let arr=JSON.parse(JSON.stringify(dataArr))
          arr=arr.filter(item=>item.id==$(this).attr("id"))
          dataArr=dataArr.filter(item=>item.id!=$(this).attr("id"))
            dataArr.unshift(...arr)
            showData(dataArr)
          }else{
            dataArr=dataArr.filter(item=>item.id!=$(this).attr("id"))
            showData(dataArr)
                     $(this).parents(".bundleProduct").removeClass("bundle-selected")
         }
        })
    $('.addToCart-button').click(function(){
      let arr=[]
      arr=arr.concat(...dataArr)
      arr=arr.concat(...mainArr)

      const data=arr.map(item=>({
        id:item.id,
        quantity:item.quantity
      }))
      $.ajax({
                type : "POST",
                url : window.Shopify.routes.root + 'cart/add.js',
                dataType : "json",
                data : {items:data},
                success : function(test) {
                   window.location.href="/cart"
                },
            });
    })
    let mobileDataArr=[]
    let mobileMainArr=[]
    if(mobileMainArr.length==0){
       mobileMainArr.push({
      id:$(".thisItem").attr("id"),
        image:$(".thisItem").attr("image"),
        quantity:1,
        title:$(".thisItem").attr("title")
    })
    }
        
    $(".mobile-main-bundle .mobile-bundleReduce").click(function(){
      if($(this).next().val()>1){
            $(this).next().val($(this).next().val()-1)  
            mobileMainArr.forEach((item,index)=>{
              if(item.id==$(this).attr("id")){
              item.quantity=item.quantity-1
              }
            })
         }
    })
    $(".mobile-main-bundle .mobile-bundleAdd").click(function(){
           $(this).prev().val(+$(this).prev().val()+1)  
            mobileMainArr.forEach((item,index)=>{
              if(item.id==$(this).attr("id")){
              item.quantity= +item.quantity+1
              }
            })
              })
        $(".mobile-main-bundle .mobile-kongzhi").change(function(){
          if($(this).val()>0){
            mobileMainArr.forEach((item,index)=>{
              if(item.id==$(this).attr("id")){
              item.quantity=$(this).val()
              }
            })
          }else{
           $(this).val(1)  
            mobileMainArr[0].quantity=1
          }
        })
    $(".mobile-product-bundle-group .onlyAdd-bundle").click(function(){
      mobileDataArr.unshift({
        id:$(this).attr("id"),
        image:$(this).attr("image"),
        quantity:1,
        title:$(this).attr("title")
      })
      $(this).parent().prev().find('.mobile-kongzhi').val(1)
     $($(this).parents(".onlyAddBundle")).prev().css("display","flex")
     $(this).parents(".onlyAddBundle").css("display","none")
    })
    $(".mobile-product-bundle-group .mobile-bundleReduce").click(function(){
      if($(this).next().val()>1){
            $(this).next().val($(this).next().val()-1)  
            mobileDataArr.forEach((item,index)=>{
              if(item.id==$(this).attr("id")){
              item.quantity=item.quantity-1
              }
            })
         }else{
            mobileDataArr=mobileDataArr.filter(item=>item.id!=$(this).attr("id"))
          $(this).parents(".mobile-bundleQty").css("display","none")
     $($(this).parents(".mobile-bundleQty")).next().css("display","flex")
         }
    })
    $(".mobile-product-bundle-group .mobile-bundleAdd").click(function(){
           $(this).prev().val(+$(this).prev().val()+1)  
            mobileDataArr.forEach((item,index)=>{
              if(item.id==$(this).attr("id")){
              item.quantity= +item.quantity+1
              }
            })
              })
        $(".mobile-product-bundle-group .mobile-kongzhi").change(function(){
          if($(this).val()>0){
            mobileDataArr.forEach((item,index)=>{
              if(item.id==$(this).attr("id")){
              item.quantity=$(this).val()
              }
            })
          }else{
            mobileDataArr=mobileDataArr.filter(item=>item.id!=$(this).attr("id"))
            $(this).parents(".mobile-bundleQty").css("display","none")
     $($(this).parents(".mobile-bundleQty")).next().css("display","flex")
         }
        })
    $('.mobile-addToCart-button').click(function(){
      let arr=[]
      arr=arr.concat(...mobileDataArr)
      arr=arr.concat(...mobileMainArr)

      const data=arr.map(item=>({
        id:item.id,
        quantity:item.quantity
      }))
      $.ajax({
                type : "POST",
                url : window.Shopify.routes.root + 'cart/add.js',
                dataType : "json",
                data : {items:data},
                success : function(test) {
                   window.location.href="/cart"
                },
            });
    })
}()
  !function(){
    let specialTag = $('.content-detail')
const scrollEvent = function () {
    $('.tab-detail-content-one-solution .active_underline').removeClass("active-solution")
        $('.tab-detail-content-one-solution').removeClass("active-tab-detail-content-one-solution");
    for (let i = specialTag.length - 1; i >= 0; i--) {
        if ($(window).scrollTop() > $(specialTag[i]).offset().top - 150) {
            $($($('.tab-detail-content-one-solution')[i]).find(".active_underline")).addClass("active-solution")
      $($('.tab-detail-content-one-solution')[i]).addClass("active-tab-detail-content-one-solution")
            return
        }
    }
}
window.addEventListener("scroll", scrollEvent)
let specialInterval
$('.tab-detail-content-one-solution').click(function () {
    $('html,body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 80
    }, 500);
    window.removeEventListener("scroll", scrollEvent);
    clearTimeout(specialInterval)
    specialInterval = setTimeout(() => {
        $('.tab-detail-content-one-solution .active_underline').removeClass("active-solution");
        $('.tab-detail-content-one-solution').removeClass("active-tab-detail-content-one-solution");
      
       $(this).addClass("active-tab-detail-content-one-solution")
       $($(this).find(".active_underline")).addClass("active-solution")
window.addEventListener("scroll", scrollEvent)
    }, 500)
    // return false;
});
  }()

 !function(){
   window.addEventListener('onload',function(){
     const divBody = $('.full-content-blog-detail-customize-body ')
   
  let arrBody=[]
  for(let i=0 ;i<divBody.length;i++){
    arrBody.push($(divBody[i]).height())
  }
  arrBody.sort((a,b)=>b-a)
   console.log(arrBody)
  divBody.height(arrBody[0])
    window.addEventListener('resize', function() {
    divBody.height('')
    let arrBody=[]
  for(let i=0 ;i<divBody.length;i++){
    arrBody.push($(divBody[i]).height())
  }
  arrBody.sort((a,b)=>b-a)
  divBody.height(arrBody[0])
  })
})
   
  }()